(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3557],{

/***/ 49044:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TagColor */
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Tag_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28742);
/* harmony import */ var _Tag_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Tag_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["color"];




var TagColor;

(function (TagColor) {
  TagColor["Default"] = "default";
  TagColor["Station"] = "station";
  TagColor["Gray"] = "gray";
})(TagColor || (TagColor = {}));

var Tag = function Tag(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? TagColor.Default : _ref$color,
      props = (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_Tag_module_scss__WEBPACK_IMPORTED_MODULE_4___default().Tag), (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_Tag_module_scss__WEBPACK_IMPORTED_MODULE_4___default().isGray), color === TagColor.Station), (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_Tag_module_scss__WEBPACK_IMPORTED_MODULE_4___default().isGray), color === TagColor.Gray), props.className);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
    className: classes,
    children: props.children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Tag);

/***/ }),

/***/ 57307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Icon_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84751);
/* harmony import */ var _Icon_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Icon_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





var Icon = function Icon(_ref) {
  var className = _ref.className,
      name = _ref.name;
  var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_Icon_module_scss__WEBPACK_IMPORTED_MODULE_3___default().Icon), className);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
    className: classes,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("use", {
      xlinkHref: "#".concat(name)
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Icon);

/***/ }),

/***/ 56922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ MultipleLineTruncate; },
/* harmony export */   "d": function() { return /* binding */ SingleLineTruncate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_lines_ellipsis__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37188);
/* harmony import */ var react_lines_ellipsis_lib_html__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86181);
/* harmony import */ var react_lines_ellipsis_lib_html__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_lines_ellipsis_lib_html__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_lines_ellipsis_lib_responsiveHOC__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16028);
/* harmony import */ var react_lines_ellipsis_lib_responsiveHOC__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_lines_ellipsis_lib_responsiveHOC__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var xss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68924);
/* harmony import */ var xss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(xss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_StringUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16197);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);







var ResponsiveHTMLEllipsis = react_lines_ellipsis_lib_responsiveHOC__WEBPACK_IMPORTED_MODULE_3___default()()((react_lines_ellipsis_lib_html__WEBPACK_IMPORTED_MODULE_2___default())); // SingleLineTruncateは responsiveHOC()(LineEllipsis) をそのまま使う

var SingleLineTruncate = react_lines_ellipsis_lib_responsiveHOC__WEBPACK_IMPORTED_MODULE_3___default()()(react_lines_ellipsis__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);

// MultipleLineTruncateは渡された文字列をエスケープした後に、改行を<br>タグに変換して表示します
var MultipleLineTruncate = function MultipleLineTruncate(_ref) {
  var className = _ref.className,
      maxLine = _ref.maxLine,
      onReflow = _ref.onReflow,
      text = _ref.text;
  // 先にエスケープしてしまう
  var escaped = (0,xss__WEBPACK_IMPORTED_MODULE_4__.filterXSS)(text); // 改行を<br>に変更

  var unsafeHTML = _utils_StringUtils__WEBPACK_IMPORTED_MODULE_5__/* ["default"].nl2brString */ .Z.nl2brString(escaped);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(ResponsiveHTMLEllipsis, {
    className: className,
    unsafeHTML: unsafeHTML,
    maxLine: maxLine,
    ellipsis: "...",
    basedOn: "letters",
    onReflow: onReflow
  });
};



/***/ }),

/***/ 58750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_BaseLayoutMerchantWithShortHeader; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/layouts/BaseLayout.module.scss
var BaseLayout_module = __webpack_require__(77568);
var BaseLayout_module_default = /*#__PURE__*/__webpack_require__.n(BaseLayout_module);
// EXTERNAL MODULE: ./src/components/layouts/MerchantGlobalFooter/index.tsx + 2 modules
var MerchantGlobalFooter = __webpack_require__(81016);
// EXTERNAL MODULE: ./src/components/layouts/GlobalNav/GlobalNav.tsx + 2 modules
var GlobalNav = __webpack_require__(21878);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/layouts/PurchaseFlowMerchantHeader/PurchaseFlowMerchantHeader.module.scss
var PurchaseFlowMerchantHeader_module = __webpack_require__(18170);
var PurchaseFlowMerchantHeader_module_default = /*#__PURE__*/__webpack_require__.n(PurchaseFlowMerchantHeader_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/layouts/PurchaseFlowMerchantHeader/index.tsx







var PurchaseFlowMerchantHeader = function PurchaseFlowMerchantHeader(_ref) {
  var className = _ref.className,
      publicId = _ref.publicId,
      displayName = _ref.displayName,
      thumbnailUrl = _ref.thumbnailUrl,
      isShowProfileImage = _ref.isShowProfileImage;
  var classes = classnames_default()((PurchaseFlowMerchantHeader_module_default()).PurchaseFlowMerchantHeader, className);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classes,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (PurchaseFlowMerchantHeader_module_default()).PurchaseFlowMerchantHeader__Inner,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)((link_default()), {
        href: "/".concat(publicId),
        prefetch: false,
        className: (PurchaseFlowMerchantHeader_module_default()).PurchaseFlowMerchantHeader__Link,
        children: [isShowProfileImage && /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (PurchaseFlowMerchantHeader_module_default()).PurchaseFlowMerchantHeader__Image,
          src: thumbnailUrl,
          alt: ""
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (PurchaseFlowMerchantHeader_module_default()).PurchaseFlowMerchantHeader__Description,
          children: displayName
        })]
      })
    })
  });
};

/* harmony default export */ var layouts_PurchaseFlowMerchantHeader = (PurchaseFlowMerchantHeader);
;// CONCATENATED MODULE: ./src/components/layouts/BaseLayoutMerchantWithShortHeader.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var BaseLayoutMerchantWithShortHeader = function BaseLayoutMerchantWithShortHeader(props) {
  var _props$merchantProps;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classnames_default()((BaseLayout_module_default()).BaseLayout, props.className),
    children: [!props.isCoubicApp && props.merchantProps && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(GlobalNav/* default */.Z, {
        logoImage: props.logoImage,
        merchantPublicId: props.merchantPublicId,
        displayName: (_props$merchantProps = props.merchantProps) === null || _props$merchantProps === void 0 ? void 0 : _props$merchantProps.displayName
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(layouts_PurchaseFlowMerchantHeader, _objectSpread({}, props.merchantProps))]
    }), props.children, !props.isCoubicApp && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (BaseLayout_module_default()).BaseLayout__Footer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantGlobalFooter/* default */.Z, {})
    })]
  });
};

/* harmony default export */ var layouts_BaseLayoutMerchantWithShortHeader = (BaseLayoutMerchantWithShortHeader);

/***/ }),

/***/ 16197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92777);
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82262);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55877);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(uuid__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var StringUtils = /*#__PURE__*/function () {
  function StringUtils() {
    (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, StringUtils);
  }

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(StringUtils, null, [{
    key: "nl2brString",
    value: function nl2brString(text) {
      var regex = /(\n)/g;
      return text.split(regex).map(function (line) {
        if (line.match(regex)) {
          return "<br />";
        }

        return line;
      }).join('');
    }
  }, {
    key: "simpleFormat",
    value: function simpleFormat(text) {
      var regex = /\r?\n/g;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: text.split(regex).map(function (p) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
            children: p ? p : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("br", {}, (0,uuid__WEBPACK_IMPORTED_MODULE_1__.v4)())
          }, (0,uuid__WEBPACK_IMPORTED_MODULE_1__.v4)());
        })
      });
    }
  }]);

  return StringUtils;
}();

/* harmony default export */ __webpack_exports__["Z"] = (StringUtils);

/***/ }),

/***/ 1885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J3": function() { return /* binding */ BookingPageList; },
/* harmony export */   "Jk": function() { return /* binding */ BookingPageTagName; },
/* harmony export */   "Xh": function() { return /* binding */ BookingPageBookable; },
/* harmony export */   "q0": function() { return /* binding */ BookingPageScheme; }
/* harmony export */ });
/* unused harmony exports BookingPageCoverContentType, BookingPageStatus, BookingPageVacancyVisibility, BookingPageCoverContent, default, Pagination */
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82262);
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92777);
/* harmony import */ var _home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);



var BookingPageCoverContentType;

(function (BookingPageCoverContentType) {
  BookingPageCoverContentType["UploadImage"] = "upload_image";
  BookingPageCoverContentType["Embed"] = "embed";
})(BookingPageCoverContentType || (BookingPageCoverContentType = {}));

var BookingPageScheme;

(function (BookingPageScheme) {
  BookingPageScheme["Availability"] = "AVAILABILITY_SCHEME";
  BookingPageScheme["Event"] = "EVENT_SCHEME";
  BookingPageScheme["Assign"] = "ASSIGN_SCHEME";
  BookingPageScheme["School"] = "SCHOOL_SCHEME";
  BookingPageScheme["Post"] = "POST_SCHEME";
  BookingPageScheme["Text"] = "TEXT_SCHEME";
  BookingPageScheme["Photo"] = "PHOTO_SCHEME";
})(BookingPageScheme || (BookingPageScheme = {}));

var BookingPageStatus;

(function (BookingPageStatus) {
  BookingPageStatus["Unpublished"] = "unpublished";
  BookingPageStatus["Closed"] = "closed";
  BookingPageStatus["FullyBooked"] = "fully_booked";
  BookingPageStatus["Accepting"] = "accepting";
})(BookingPageStatus || (BookingPageStatus = {}));

var BookingPageVacancyVisibility;

(function (BookingPageVacancyVisibility) {
  BookingPageVacancyVisibility["Hidden"] = "hidden";
  BookingPageVacancyVisibility["NoCapacity"] = "no_capacity";
})(BookingPageVacancyVisibility || (BookingPageVacancyVisibility = {}));

var BookingPageTagName;

(function (BookingPageTagName) {
  BookingPageTagName["Accepting"] = "accepting";
  BookingPageTagName["RequireAcceptance"] = "require_acceptance";
  BookingPageTagName["BankTransfer"] = "bank_transfer";
  BookingPageTagName["Onsite"] = "onsite";
  BookingPageTagName["CreditCard"] = "credit_card";
  BookingPageTagName["Ticket"] = "ticket";
  BookingPageTagName["Subscription"] = "subscription";
})(BookingPageTagName || (BookingPageTagName = {}));

var BookingPageCoverContent = /*#__PURE__*/(0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function BookingPageCoverContent(init) {
  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, BookingPageCoverContent);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "url", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "embed", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "thumbnailUrl", void 0);

  this.url = init.url;
  this.embed = init.embed;
  this.thumbnailUrl = init.thumbnail_url;
});

/**
 * @deprecated 定義が分散しているので、MerchantBooking に統一したい
 */
var BookingPage = /*#__PURE__*/(0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function BookingPage(_init) {
  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, BookingPage);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "coverContent", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "coverContentType", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "description", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "name", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "paymentMethods", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "lowestPrice", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "uniquePricing", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "publicId", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "primaryImage", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "scheme", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "status", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "tagNames", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "vacancyVisibility", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "waitingListProvided", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "thumbnailUrl", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "initThumbnailUrl", function (init) {
    // image
    if (init.primary_image) {
      return init.primary_image.square.url;
    } // video


    if (init.cover_content) {
      return init.cover_content.thumbnail_url;
    } // nothing


    return '';
  });

  if (_init.cover_content) {
    this.coverContent = new BookingPageCoverContent(_init.cover_content);
  }

  this.coverContentType = _init.cover_contents_type;
  this.name = _init.name;
  this.paymentMethods = {
    onlinePaymentEnabled: _init.payment_settings_enabled,
    onsitePaymentEnabled: _init.onsite_payment_enabled,
    payableWithPrepayment: _init.prepayment_enabled,
    payableWithSubscription: _init.payable_with_subscription,
    payableWithTicket: _init.payable_with_ticket
  };
  this.lowestPrice = _init.lowest_price;
  this.uniquePricing = _init.unique_pricing;
  this.publicId = _init.public_id;
  this.primaryImage = _init.primary_image;
  this.scheme = _init.model_type;
  this.status = _init.status;
  this.tagNames = _init.tag_names;
  this.vacancyVisibility = _init.vacancy_visibility;
  this.waitingListProvided = _init.waiting_list_provided;
  this.description = {
    isJson: _init.is_json_description,
    json: _init.description,
    text: _init.description_text
  };
  this.thumbnailUrl = this.initThumbnailUrl(_init);
});


var BookingPageBookable = /*#__PURE__*/(0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function BookingPageBookable(init) {
  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, BookingPageBookable);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "accepting", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "protected", void 0);

  this.accepting = init.bookable.accepting;
  this["protected"] = init.bookable["protected"];
});
var Pagination = /*#__PURE__*/(0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function Pagination(inits) {
  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, Pagination);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "size", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "totalSize", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "totalPages", void 0);

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "currentPage", void 0);

  this.size = inits.size;
  this.totalSize = inits.total_size;
  this.totalPages = inits.total_pages;
  this.currentPage = inits.current_page;
});
var BookingPageList = /*#__PURE__*/function () {
  function BookingPageList(inits) {
    var _this = this;

    (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, BookingPageList);

    (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "pagination", void 0);

    (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this, "bookingPages", void 0);

    this.pagination = new Pagination(inits);
    this.bookingPages = [];
    inits.data.map(function (init) {
      _this.bookingPages.push(new BookingPage(init));
    });
  }

  (0,_home_runner_work_rsv_frontend_rsv_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(BookingPageList, [{
    key: "tagNames",
    get: function get() {
      var tagNames = new Map();
      this.bookingPages.forEach(function (b) {
        tagNames[b.publicId] = b.tagNames;
      });
      return tagNames;
    }
  }]);

  return BookingPageList;
}();

/***/ }),

/***/ 51295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ usePushMerchantDataLayerEffect; },
/* harmony export */   "U": function() { return /* binding */ usePushPurchaseEventToDataLayer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _api_me__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21966);
/* harmony import */ var _utils_gtag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7788);



var usePushMerchantDataLayerEffect = function usePushMerchantDataLayerEffect(params) {
  var _useUserMe = (0,_api_me__WEBPACK_IMPORTED_MODULE_1__/* .useUserMe */ .J1)(),
      user = _useUserMe.user,
      isUserLoading = _useUserMe.isUserLoading;

  var loginMerchantId = (user === null || user === void 0 ? void 0 : user.role) === 'admin' ? user.id : undefined;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isUserLoading) return;
    window.gtmDataLayer = window.gtmDataLayer || [];
    window.gtmDataLayer.push({
      login_user_id: user === null || user === void 0 ? void 0 : user.id,
      visit_merchant_id: params.visit_merchant_id,
      login_merchant_id: loginMerchantId
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      login_user_id: user === null || user === void 0 ? void 0 : user.id,
      visit_merchant_id: params.visit_merchant_id,
      login_merchant_id: loginMerchantId
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, isUserLoading]);
};
var usePushPurchaseEventToDataLayer = function usePushPurchaseEventToDataLayer(params) {
  var isPurchaseEventSent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!isPurchaseEventSent.current) {
      _utils_gtag__WEBPACK_IMPORTED_MODULE_2__/* .purchaseEvent */ .mG({
        step: 'completion',
        productPublicId: params.productId,
        customerPublicId: params.customerId
      });
      isPurchaseEventSent.current = true;
    }
  });
};

/***/ }),

/***/ 14618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useShallowEqualSelector; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66338);

var useShallowEqualSelector = function useShallowEqualSelector(selector) {
  return (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(selector, react_redux__WEBPACK_IMPORTED_MODULE_0__/* .shallowEqual */ .wU);
};

/***/ }),

/***/ 12085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ MerchantProductStatus; }
/* harmony export */ });
var MerchantProductStatus;

(function (MerchantProductStatus) {
  MerchantProductStatus["Unpublished"] = "unpublished";
  MerchantProductStatus["NotForSale"] = "not_for_sale";
  MerchantProductStatus["Accepting"] = "accepting";
})(MerchantProductStatus || (MerchantProductStatus = {}));

/***/ }),

/***/ 17105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_LineTruncate__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56922);
/* harmony import */ var _tags_MerchantTag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16564);
/* harmony import */ var _texts_LowestPrice__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17132);
/* harmony import */ var _BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20655);
/* harmony import */ var _BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);










var BookingPageCard = function BookingPageCard(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard), props.className),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
      href: props.url,
      prefetch: false,
      className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Link),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        children: [props.thumbnailUrl && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Thumbnail),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__ThumbnailImage),
            style: {
              backgroundImage: "url(".concat(props.thumbnailUrl, ")")
            }
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Heading),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_LineTruncate__WEBPACK_IMPORTED_MODULE_3__/* .SingleLineTruncate */ .d, {
            maxLine: 2,
            text: props.title
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Description),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_LineTruncate__WEBPACK_IMPORTED_MODULE_3__/* .MultipleLineTruncate */ .Q, {
            maxLine: 3,
            text: props.description
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Clearfix)
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Footer),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Tags),
          children: props.tags && props.tags.length > 0 && props.tags.map(function (tag, i) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_tags_MerchantTag__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              status: tag
            }, i);
          })
        }), props.lowestPrice !== undefined && props.lowestPrice !== null && props.uniquePricing !== undefined && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: (_BookingPageCard_module_scss__WEBPACK_IMPORTED_MODULE_7___default().BookingPageCard__Price),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_texts_LowestPrice__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            lowestPrice: props.lowestPrice,
            uniquePricing: props.uniquePricing
          })
        })]
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BookingPageCard);

/***/ }),

/***/ 16564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6292);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20320);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86896);
/* harmony import */ var _atoms_Tag__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49044);
/* harmony import */ var _MerchantTag_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77050);
/* harmony import */ var _MerchantTag_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_MerchantTag_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var MerchantTag = function MerchantTag(_ref) {
  var status = _ref.status;
  var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();

  var classes = function classes(courseStatus) {
    return classnames__WEBPACK_IMPORTED_MODULE_0___default()((_MerchantTag_module_scss__WEBPACK_IMPORTED_MODULE_5___default().MerchantTag), (_MerchantTag_module_scss__WEBPACK_IMPORTED_MODULE_5___default())["is".concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,lodash_es__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(courseStatus)))]);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_atoms_Tag__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    className: classes(status),
    children: intl.formatMessage({
      id: "merchants.bookingPages.status.".concat((0,lodash_es__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(status))
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MerchantTag);

/***/ }),

/***/ 17132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86896);
/* harmony import */ var _LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92706);
/* harmony import */ var _LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);








var LowestPrice = function LowestPrice(props) {
  var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  return props.lowestPrice == null ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("span", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4___default().LowestPrice), props.className),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
      className: (_LowestPrice_module_scss__WEBPACK_IMPORTED_MODULE_4___default().LowestPrice__Emphasis),
      children: intl.formatNumber(props.lowestPrice)
    }), intl.formatMessage({
      id: props.uniquePricing ? 'merchants.common.lowestPrice.single_unit' : 'merchants.common.lowestPrice.multi_unit'
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (LowestPrice);

/***/ }),

/***/ 13513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ products_MerchantProductProtectedPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/molecules/common/LabeledContainer/index.tsx
var LabeledContainer = __webpack_require__(88849);
// EXTERNAL MODULE: ./src/atoms/FormErrorMessage/index.tsx
var FormErrorMessage = __webpack_require__(77362);
// EXTERNAL MODULE: ./src/atoms/TextInput/index.tsx
var TextInput = __webpack_require__(33668);
// EXTERNAL MODULE: ./public/static/books/secret.png
var secret = __webpack_require__(82461);
var secret_default = /*#__PURE__*/__webpack_require__.n(secret);
// EXTERNAL MODULE: ./src/molecules/merchant/products/MerchantProductProtectedPage/MerchantProductProtectedPage.module.scss
var MerchantProductProtectedPage_module = __webpack_require__(80028);
var MerchantProductProtectedPage_module_default = /*#__PURE__*/__webpack_require__.n(MerchantProductProtectedPage_module);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/infrastructure/api/index.ts
var api = __webpack_require__(39851);
// EXTERNAL MODULE: ./src/utils/secured-axios.ts
var secured_axios = __webpack_require__(25363);
;// CONCATENATED MODULE: ./src/infrastructure/repositories/ProductRepository.ts









/**
 * NOTE: use coubic v2 api
 */
var ProductRepository = /*#__PURE__*/function () {
  function ProductRepository(api) {
    (0,classCallCheck/* default */.Z)(this, ProductRepository);

    (0,defineProperty/* default */.Z)(this, "api", void 0);

    this.api = api;
  }

  (0,createClass/* default */.Z)(ProductRepository, [{
    key: "PasswordVerify",
    value: function () {
      var _PasswordVerify = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(publicId, productPublicId, password) {
        var path;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                path = "".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(publicId, "/products/").concat(productPublicId, "/verify");
                return _context.abrupt("return", this.api.post(path, {
                  password: password
                }).then(function (response) {
                  return response.status === 200;
                })["catch"](function (err) {
                  var _err$response;

                  if (axios_default().isAxiosError(err) && ((_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 401) {
                    return false;
                  }

                  return Promise.reject(err);
                }));

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function PasswordVerify(_x, _x2, _x3) {
        return _PasswordVerify.apply(this, arguments);
      }

      return PasswordVerify;
    }()
  }, {
    key: "IsProtected",
    value: function () {
      var _IsProtected = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(publicId, productPublicId) {
        var path, res, isProtected, siteUnpublishedHeader, isUnpublishedSite, _error$response, _siteUnpublishedHeader, _isUnpublishedSite;

        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                path = "".concat((0,api/* apiRoot */.bI)(), "/merchants/").concat(publicId, "/products/").concat(productPublicId, "/protected");
                _context2.prev = 1;
                _context2.next = 4;
                return this.api.get(path);

              case 4:
                res = _context2.sent;
                isProtected = res.status === 200 ? res.data["protected"] : undefined;
                siteUnpublishedHeader = res.headers['x-coubic-site-unpublished'];
                isUnpublishedSite = siteUnpublishedHeader ? Boolean(siteUnpublishedHeader) : false;
                return _context2.abrupt("return", {
                  isProtected: isProtected,
                  isUnpublishedSite: isUnpublishedSite
                });

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](1);

                if (!axios_default().isAxiosError(_context2.t0)) {
                  _context2.next = 19;
                  break;
                }

                _siteUnpublishedHeader = (_error$response = _context2.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.headers['x-coubic-site-unpublished'];
                _isUnpublishedSite = _siteUnpublishedHeader ? Boolean(_siteUnpublishedHeader) : false;
                return _context2.abrupt("return", {
                  isProtected: false,
                  isUnpublishedSite: _isUnpublishedSite
                });

              case 19:
                throw _context2.t0;

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 11]]);
      }));

      function IsProtected(_x4, _x5) {
        return _IsProtected.apply(this, arguments);
      }

      return IsProtected;
    }()
  }]);

  return ProductRepository;
}();
/* harmony default export */ var repositories_ProductRepository = (new ProductRepository(secured_axios/* default */.ZP)); // SSRでAPIリクエストを行いたい場合、session情報を明示的に載せる必要があるため、
// こっちのメソッドから生成されたインスタンスを利用する

var ProductRepositoryForSSR = function ProductRepositoryForSSR(session, token, requestId) {
  return new ProductRepository(newSecuredAxios({
    session: session,
    token: token,
    requestId: requestId
  }));
};
// EXTERNAL MODULE: ./src/reservation-page/RSButton/index.tsx
var RSButton = __webpack_require__(17940);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/molecules/merchant/products/MerchantProductProtectedPage/index.tsx















var MerchantProductProtectedPage = function MerchantProductProtectedPage(_ref) {
  var publicId = _ref.publicId,
      productPublicId = _ref.productPublicId,
      onSubmit = _ref.onSubmit;
  var intl = (0,useIntl/* default */.Z)();

  var _useState = (0,react.useState)(''),
      password = _useState[0],
      setPassword = _useState[1];

  var _useState2 = (0,react.useState)(false),
      posted = _useState2[0],
      setPosted = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      posting = _useState3[0],
      setPosting = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      result = _useState4[0],
      setResult = _useState4[1];

  var handleChange = (0,react.useCallback)(function (e) {
    setPassword(e.currentTarget.value);
  }, []);
  var handleSubmit = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var verifyResult;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setPosting(true);
            _context.next = 3;
            return repositories_ProductRepository.PasswordVerify(publicId, productPublicId, password);

          case 3:
            verifyResult = _context.sent;
            setPosted(true);
            setPosting(false);
            setResult(verifyResult);
            onSubmit(verifyResult);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [onSubmit, password, publicId, productPublicId]);
  var classes = classnames_default()((MerchantProductProtectedPage_module_default()).MerchantProductProtectedPage);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
      className: (MerchantProductProtectedPage_module_default()).MerchantProductProtectedPage__Img,
      src: (secret_default()),
      alt: ""
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
      className: (MerchantProductProtectedPage_module_default()).MerchantProductProtectedPage__Notes,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
        className: (MerchantProductProtectedPage_module_default()).MerchantProductProtectedPage__Heading,
        children: intl.formatMessage({
          id: 'merchants.secret.notes.heading'
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
        className: (MerchantProductProtectedPage_module_default()).MerchantProductProtectedPage__Description,
        children: intl.formatMessage({
          id: 'merchants.secret.notes.description'
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (MerchantProductProtectedPage_module_default()).MerchantProductProtectedPage__Password,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabeledContainer/* default */.Z, {
        label: intl.formatMessage({
          id: 'merchants.secret.password'
        }),
        errorStyle: posted && !result,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
          type: TextInput/* TextInputType.Password */.L.Password,
          value: password,
          onChange: handleChange
        })
      }), posted && !result && /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
        children: intl.formatMessage({
          id: 'merchants.secret.errorMessages'
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex justify-center px-[18px] py-2.5",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "min-w-[164px]",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(RSButton/* RSButton */.F, {
          variant: "basic",
          isBlock: true,
          isLoading: posting,
          disabled: !password || posting,
          type: "button",
          value: intl.formatMessage({
            id: 'books.submitLabel.ok'
          }),
          onClick: handleSubmit,
          children: intl.formatMessage({
            id: 'books.submitLabel.ok'
          })
        })
      })
    })]
  });
};

/* harmony default export */ var products_MerchantProductProtectedPage = (MerchantProductProtectedPage);

/***/ }),

/***/ 26653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ purchase; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/components/layouts/MetaTags.tsx
var MetaTags = __webpack_require__(92651);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 23 modules
var es = __webpack_require__(66338);
// EXTERNAL MODULE: ./src/interfaces/merchants/products/purchases/index.ts
var purchases = __webpack_require__(17331);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./src/redux/reducers/merchants/products/purchases/index.ts + 1 modules
var products_purchases = __webpack_require__(66048);
// EXTERNAL MODULE: ./src/redux/reducers/merchants/products/purchases/inputs.ts
var inputs = __webpack_require__(54469);
// EXTERNAL MODULE: ./src/redux/reducers/users/index.ts
var users = __webpack_require__(30627);
// EXTERNAL MODULE: ./src/redux/actions/users/api.ts
var api = __webpack_require__(70702);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/infrastructure/api/index.ts
var infrastructure_api = __webpack_require__(39851);
// EXTERNAL MODULE: ./src/utils/secured-axios.ts
var secured_axios = __webpack_require__(25363);
;// CONCATENATED MODULE: ./src/redux/actions/merchants/products/purchases/apiBodyBuilder.ts

var withUserInfo = function withUserInfo(userInfo) {
  var struct = {};
  var customerFields = userInfo.customerFields;
  var attributes = [];

  if (customerFields) {
    Object.keys(customerFields).forEach(function (k) {
      if (customerFields[k] !== '') {
        attributes.push({
          binder_id: k,
          value: customerFields[k]
        });
      }
    });
  }

  struct.customer_custom_fields = {
    customer_custom_field_responses_attributes: attributes
  };
  return struct;
};

var toPaymentMethod = function toPaymentMethod(payment) {
  if (payment.selection === purchases/* PaymentSelection.AnotherCreditCard */.fS.AnotherCreditCard) {
    // カード利用歴があるが、新しく生成する
    return {
      ctok: payment.token,
      method: 'credit_card',
      restore_credit_card: false
    };
  }

  if (payment.selection === purchases/* PaymentSelection.UsedCreditCard */.fS.UsedCreditCard) {
    // カード利用歴があり、以前のカードを利用する
    return {
      method: 'credit_card',
      restore_credit_card: true
    };
  }

  throw new Error("cannot create payment: payment ".concat(payment));
};

var withPayment = function withPayment(payment) {
  return {
    payment_method: toPaymentMethod(payment)
  };
};
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
;// CONCATENATED MODULE: ./src/redux/actions/merchants/products/purchases/api.ts



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var fetchProduct = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(merchantPublicId, productPublicId) {
    var _yield$securedAxios$g, data;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return secured_axios/* default.get */.ZP.get("".concat((0,infrastructure_api/* apiRoot */.bI)(), "/merchants/").concat(merchantPublicId, "/products/").concat(productPublicId));

          case 2:
            _yield$securedAxios$g = _context.sent;
            data = _yield$securedAxios$g.data;
            return _context.abrupt("return", data);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchProduct(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var fetchCustomFields = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(productId) {
    var _yield$securedAxios$g2, data;

    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return secured_axios/* default.get */.ZP.get("".concat((0,infrastructure_api/* apiRoot */.bI)(), "/products/").concat(productId, "/custom_fields"));

          case 2:
            _yield$securedAxios$g2 = _context2.sent;
            data = _yield$securedAxios$g2.data;
            return _context2.abrupt("return", data);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchCustomFields(_x3) {
    return _ref2.apply(this, arguments);
  };
}();
var fetchConfirmation = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(productId) {
    var _yield$securedAxios$g3, data;

    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return secured_axios/* default.get */.ZP.get("".concat((0,infrastructure_api/* apiRoot */.bI)(), "/products/").concat(productId, "/rules"));

          case 2:
            _yield$securedAxios$g3 = _context3.sent;
            data = _yield$securedAxios$g3.data;
            return _context3.abrupt("return", data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchConfirmation(_x4) {
    return _ref3.apply(this, arguments);
  };
}();
var fetchMerchantProductFirstCharge = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(merchantPublicId, productPublicId) {
    var _yield$securedAxios$g4, data;

    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return secured_axios/* default.get */.ZP.get("".concat((0,infrastructure_api/* apiRoot */.bI)(), "/merchants/").concat(merchantPublicId, "/products/").concat(productPublicId, "/first_charge"));

          case 2:
            _yield$securedAxios$g4 = _context4.sent;
            data = _yield$securedAxios$g4.data;
            return _context4.abrupt("return", data);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function fetchMerchantProductFirstCharge(_x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();

var inputsToPostStructure = function inputsToPostStructure(inputs) {
  var postObject = {};

  if (inputs.userInfo) {
    var userInfo = withUserInfo(inputs.userInfo);
    postObject = _objectSpread(_objectSpread({}, postObject), userInfo);
  }

  if (inputs.payment) {
    var payment = withPayment(inputs.payment);
    postObject = _objectSpread(_objectSpread({}, postObject), payment);
  }

  return postObject;
};

var _postPurchasing = /*#__PURE__*/function () {
  var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(url, reqData) {
    var _yield$securedAxios$p, data;

    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return secured_axios/* default.post */.ZP.post(url, reqData);

          case 3:
            _yield$securedAxios$p = _context5.sent;
            data = _yield$securedAxios$p.data;
            return _context5.abrupt("return", data);

          case 8:
            _context5.prev = 8;
            _context5.t0 = _context5["catch"](0);

            if (!(axios_default().isAxiosError(_context5.t0) && _context5.t0.response)) {
              _context5.next = 16;
              break;
            }

            if (!(_context5.t0.response.status === 400)) {
              _context5.next = 15;
              break;
            }

            return _context5.abrupt("return", _objectSpread({}, _context5.t0.response.data));

          case 15:
            return _context5.abrupt("return", {
              success: false
            });

          case 16:
            throw _context5.t0;

          case 17:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 8]]);
  }));

  return function _postPurchasing(_x7, _x8) {
    return _ref5.apply(this, arguments);
  };
}();

var purchasingUrl = function purchasingUrl(schemeType) {
  if (schemeType === purchases/* SchemeType.Subscription */.Yr.Subscription) {
    return "".concat((0,infrastructure_api/* apiRoot */.bI)(), "/subscriptions");
  }

  if (schemeType === purchases/* SchemeType.TicketBook */.Yr.TicketBook) {
    return "".concat((0,infrastructure_api/* apiRoot */.bI)(), "/ticket_books");
  }

  throw new Error("cannot create url: schemeType ".concat(schemeType));
};

var postPurchasingCustomer = /*#__PURE__*/function () {
  var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(schemeType, productId, inputs) {
    return regenerator_default().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.t0 = _postPurchasing;
            _context6.t1 = "".concat(purchasingUrl(schemeType), "/validate/customer");
            _context6.next = 4;
            return inputsToPostStructure(inputs);

          case 4:
            _context6.t2 = _context6.sent;
            _context6.t3 = productId;
            _context6.t4 = {
              input: _context6.t2,
              product_id: _context6.t3
            };
            return _context6.abrupt("return", (0, _context6.t0)(_context6.t1, _context6.t4));

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function postPurchasingCustomer(_x9, _x10, _x11) {
    return _ref6.apply(this, arguments);
  };
}();
var postPurchasingPayment = /*#__PURE__*/function () {
  var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(schemeType, productId, inputs) {
    return regenerator_default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.t0 = _postPurchasing;
            _context7.t1 = "".concat(purchasingUrl(schemeType), "/validate/payment");
            _context7.next = 4;
            return inputsToPostStructure(inputs);

          case 4:
            _context7.t2 = _context7.sent;
            _context7.t3 = productId;
            _context7.t4 = {
              input: _context7.t2,
              product_id: _context7.t3
            };
            return _context7.abrupt("return", (0, _context7.t0)(_context7.t1, _context7.t4));

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function postPurchasingPayment(_x12, _x13, _x14) {
    return _ref7.apply(this, arguments);
  };
}();
var postPurchasingFinish = /*#__PURE__*/function () {
  var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8(schemeType, productId, inputs) {
    return regenerator_default().wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.t0 = _postPurchasing;
            _context8.t1 = purchasingUrl(schemeType);
            _context8.next = 4;
            return inputsToPostStructure(inputs);

          case 4:
            _context8.t2 = _context8.sent;
            _context8.t3 = productId;
            _context8.t4 = {
              input: _context8.t2,
              product_id: _context8.t3
            };
            return _context8.abrupt("return", (0, _context8.t0)(_context8.t1, _context8.t4));

          case 8:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function postPurchasingFinish(_x15, _x16, _x17) {
    return _ref8.apply(this, arguments);
  };
}();
var postStripe = /*#__PURE__*/function () {
  var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9(_payment, _jcbEnabled) {
    return regenerator_default().wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            // 事前決済が発生する導線は全て新フローに移行したはずなので、このメソッドが呼ばれることはないはず
            // M5も含めて全て新フローに移行した後に全て消す
            (0,esm_exports/* captureException */.Tb)('Never');
            throw new Error('Never');

          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function postStripe(_x18, _x19) {
    return _ref9.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./node_modules/uuid/index.js
var uuid = __webpack_require__(55877);
// EXTERNAL MODULE: ./src/utils/cookie.ts
var cookie = __webpack_require__(69769);
;// CONCATENATED MODULE: ./src/utils/purchases-step-cookie.ts


var UNDEFINED = -1;
var initialize = function initialize() {
  cookie/* setCookie */.d8('purchases.watermark', (0,uuid.v4)());
  cookie/* setCookie */.d8('purchases.seq', new Date().getTime());
  cookie/* setCookie */.d8('purchases.finishedStep', UNDEFINED);
};
var purchases_step_cookie_watermark = function watermark() {
  return cookie/* getCookie */.ej('purchases.watermark');
};
var finalize = function finalize(step) {
  cookie/* setCookie */.d8('purchases.watermark', '');
  cookie/* setCookie */.d8('purchases.finishedStep', step);
};
var setSeq = function setSeq(sequential) {
  cookie/* setCookie */.d8('purchases.seq', sequential);
};
var purchases_step_cookie_seq = function seq() {
  return (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    parseInt(cookie/* getCookie */.ej('purchases.seq', seq), 10)
  );
};
var purchases_step_cookie_finishedStep = function finishedStep() {
  var step = parseInt(cookie/* getCookie */.ej('purchases.finishedStep'), 10);
  return step === UNDEFINED ? undefined : step;
};
;// CONCATENATED MODULE: ./src/redux/actions/merchants/products/purchases/workflow.ts


function workflow_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function workflow_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? workflow_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : workflow_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var findShowStepByWatermarkControl = function findShowStepByWatermarkControl(currentWatermark, historySeq, historyStep, historyWatermark) {
  var seq = purchases_step_cookie_seq();
  var finishedStep = purchases_step_cookie_finishedStep();

  if (currentWatermark === '') {
    // 予約フローが完了した直後（リロード前）
    if (seq > historySeq) {
      // 戻る方向: historyStepが1になるまで戻り続ける
      return historyStep === 1 ? 1 : '-1';
    }

    if (seq < historySeq) {
      // 進む方向: finishedStepになるまで進み続ける
      return historyStep === finishedStep ? finishedStep : '+1';
    }

    return historyStep === 1 ? 1 : finishedStep;
  }

  if (currentWatermark !== historyWatermark) {
    // stackのwatermarkと異なるのは以下の2通り
    // 1. 完了後にreload
    // 2. 完了後にstep1までbackした後にreload
    if (seq > historySeq) {
      // 戻る方向: reloadした後はstep1が表示されているので予約フロー前まで戻る
      return '-1';
    }

    if (seq < historySeq) {
      // 進む方向: 何が何でもstep1しか表示しない
      return 1;
    }

    return historyStep === 1 ? 1 : '+1';
  } // 予約中


  return historyStep;
};

var workflow_init = function init() {
  initialize();
  history.replaceState({
    options: {
      step: 1,
      seq: purchases_step_cookie_seq(),
      watermark: purchases_step_cookie_watermark()
    }
  }, document.title, undefined);
};
var setup = function setup(options) {
  var step = options.step,
      watermark = options.watermark,
      seq = options.seq;

  if (!step && !watermark) {
    return undefined;
  }

  var current = purchases_step_cookie_watermark();

  var _step = findShowStepByWatermarkControl(current, seq, step, watermark);

  setSeq(seq);

  if (_step === '-1') {
    history.back();
    return undefined;
  }

  if (_step === '+1') {
    history.forward();
    return undefined;
  }

  return {
    step: _step,
    renew: !current
  };
};
var workflow_nextStep = function nextStep(step, completed) {
  var next = step + 1; // 同じstepがstackされている場合には載せない。

  if (history.state && history.state.options && history.state.options.step !== next) {
    if (next === 2) {
      workflow_init();
    }

    if (completed) {
      finalize(next);
    }

    var seq = new Date().getTime();
    setSeq(seq);
    history.pushState({
      options: {
        seq: seq,
        step: next,
        watermark: purchases_step_cookie_watermark()
      }
    }, document.title, undefined);
  }

  return next;
};
var tick = function tick(callbacks) {
  // 状態を維持しつつ、historyを刻みたいだけなので
  // 現時点の最新stateをそのまま上に積む
  history.pushState(workflow_objectSpread(workflow_objectSpread({}, history.state), {}, {
    tick: true
  }), document.title, undefined);

  window.onpopstate = function (e) {
    if (e.state.tick) {
      callbacks.onForwardCallback();
    } else {
      callbacks.onBackCallback();
    }
  };
};
var back = function back() {
  window.onpopstate = null;
  history.back();
};
;// CONCATENATED MODULE: ./src/redux/actions/merchants/products/purchases/index.ts



function purchases_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function purchases_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? purchases_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : purchases_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var toDataSet = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref) {
    var schemeType, productId, bookingPages;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            schemeType = _ref.schemeType, productId = _ref.productId, bookingPages = _ref.bookingPages;
            _context.t0 = schemeType;
            _context.next = _context.t0 === purchases/* SchemeType.Subscription */.Yr.Subscription ? 4 : _context.t0 === purchases/* SchemeType.TicketBook */.Yr.TicketBook ? 13 : 22;
            break;

          case 4:
            _context.t1 = schemeType;
            _context.next = 7;
            return fetchCustomFields(productId);

          case 7:
            _context.t2 = _context.sent;
            _context.next = 10;
            return fetchConfirmation(productId);

          case 10:
            _context.t3 = _context.sent;
            _context.t4 = {
              booking_pages: bookingPages
            };
            return _context.abrupt("return", {
              schemeType: _context.t1,
              customFieldsData: _context.t2,
              confirmData: _context.t3,
              useCaseData: _context.t4
            });

          case 13:
            _context.t5 = schemeType;
            _context.next = 16;
            return fetchCustomFields(productId);

          case 16:
            _context.t6 = _context.sent;
            _context.next = 19;
            return fetchConfirmation(productId);

          case 19:
            _context.t7 = _context.sent;
            _context.t8 = {
              booking_pages: bookingPages
            };
            return _context.abrupt("return", {
              schemeType: _context.t5,
              customFieldsData: _context.t6,
              confirmData: _context.t7,
              useCaseData: _context.t8
            });

          case 22:
            throw new Error("require new implementation of \"".concat(schemeType, "\""));

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function toDataSet(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var toSubscribed = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref3) {
    var schemeType, productId, usersSubscriptionData;
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            schemeType = _ref3.schemeType, productId = _ref3.productId;

            if (!(schemeType === purchases/* SchemeType.Subscription */.Yr.Subscription)) {
              _context2.next = 6;
              break;
            }

            _context2.next = 4;
            return api/* fetchUsersSubscription */.l(productId);

          case 4:
            usersSubscriptionData = _context2.sent;
            return _context2.abrupt("return", !!usersSubscriptionData);

          case 6:
            return _context2.abrupt("return", false);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function toSubscribed(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var init = function init(q) {
  return /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(dispatch) {
      var _merchant$public_id;

      var publicId, productId, isEmailVerified, usersMeData, _yield$fetchMerchantD, merchant, productData, firstCharge, dataSetAttr, dataSet, subscribed;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              publicId = q.publicId, productId = q.productId, isEmailVerified = q.isEmailVerified;
              _context3.next = 3;
              return api/* fetchUsersMe */.E();

            case 3:
              usersMeData = _context3.sent;
              _context3.next = 6;
              return (0,infrastructure_api/* fetchMerchantDetail */.uY)({
                session: '',
                token: '',
                requestId: '',
                merchantPublicId: q.publicId
              });

            case 6:
              _yield$fetchMerchantD = _context3.sent;
              merchant = _yield$fetchMerchantD.merchant;
              _context3.next = 10;
              return fetchProduct((_merchant$public_id = merchant === null || merchant === void 0 ? void 0 : merchant.public_id) !== null && _merchant$public_id !== void 0 ? _merchant$public_id : '', productId);

            case 10:
              productData = _context3.sent;

              if (!(productData.scheme === 0 // subscription schemeの場合
              )) {
                _context3.next = 17;
                break;
              }

              _context3.next = 14;
              return fetchMerchantProductFirstCharge(publicId, productId);

            case 14:
              _context3.t0 = _context3.sent;
              _context3.next = 18;
              break;

            case 17:
              _context3.t0 = null;

            case 18:
              firstCharge = _context3.t0;
              dataSetAttr = {
                schemeType: productData.scheme === 0 ? purchases/* SchemeType.Subscription */.Yr.Subscription : purchases/* SchemeType.TicketBook */.Yr.TicketBook,
                productId: productId,
                bookingPages: productData.booking_pages
              };
              _context3.next = 22;
              return toDataSet(dataSetAttr);

            case 22:
              dataSet = _context3.sent;
              _context3.next = 25;
              return toSubscribed(dataSetAttr);

            case 25:
              subscribed = _context3.sent;

              if (usersMeData) {
                dispatch({
                  payload: {
                    creditCard: usersMeData.credit_card ? {
                      canonicalId: usersMeData.credit_card.canonical_id,
                      expireMonth: usersMeData.credit_card.expire_month,
                      expireYear: usersMeData.credit_card.expire_year,
                      tailDigits: usersMeData.credit_card.tail_digits
                    } : undefined,
                    displayName: usersMeData.display_name,
                    email: usersMeData.email,
                    firstname: usersMeData.firstname,
                    id: usersMeData.id,
                    isEmailVerified: usersMeData.is_email_verified,
                    lastname: usersMeData.lastname,
                    phoneNumber: usersMeData.phone_number,
                    publicId: usersMeData.public_id
                  },
                  type: users/* Types.Me */.Y.Me
                });
              }

              dispatch({
                payload: {
                  productId: productId
                },
                type: inputs/* Types.Init */.Y.Init
              });

              if (merchant) {
                dispatch({
                  payload: purchases_objectSpread(purchases_objectSpread({}, q), {}, {
                    dataSet: dataSet,
                    productData: productData,
                    loggedIn: !!usersMeData,
                    subscribed: subscribed,
                    jcbEnabled: merchant.jcb_enabled,
                    isEmailVerified: isEmailVerified,
                    firstCharge: firstCharge
                  }),
                  type: products_purchases/* Types.Init */.Y.Init
                });
              }

              workflow_init();

            case 30:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var nextStep = function nextStep(step) {
  return function (dispatch) {
    return dispatch({
      type: products_purchases/* Types.SetStep */.Y.SetStep,
      payload: {
        step: workflow_nextStep(step, false)
      }
    });
  };
};
var finalStep = function finalStep(step) {
  return function (dispatch) {
    return dispatch({
      type: products_purchases/* Types.SetStep */.Y.SetStep,
      payload: {
        step: workflow_nextStep(step, true)
      }
    });
  };
};
var goTo = function goTo(step) {
  return function (dispatch) {
    dispatch({
      type: products_purchases/* Types.SetStep */.Y.SetStep,
      payload: {
        step: step
      }
    });
  };
};
var setPostable = function setPostable(postable) {
  return function (dispatch) {
    dispatch({
      payload: {
        postable: postable
      },
      type: products_purchases/* Types.SetPostable */.Y.SetPostable
    });
  };
};
var setMeToPurchaseInfo = function setMeToPurchaseInfo(productId) {
  return /*#__PURE__*/function () {
    var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(dispatch) {
      var usersMeData;
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.t0 = dispatch;
              _context4.next = 3;
              return fetchCustomFields(productId);

            case 3:
              _context4.t1 = _context4.sent;
              _context4.t2 = {
                customFields: _context4.t1
              };
              _context4.t3 = products_purchases/* Types.SetCustomFields */.Y.SetCustomFields;
              _context4.t4 = {
                payload: _context4.t2,
                type: _context4.t3
              };
              (0, _context4.t0)(_context4.t4);
              _context4.next = 10;
              return api/* fetchUsersMe */.E();

            case 10:
              usersMeData = _context4.sent;

              if (usersMeData) {
                dispatch({
                  payload: {
                    creditCard: usersMeData.credit_card ? {
                      canonicalId: usersMeData.credit_card.canonical_id,
                      expireMonth: usersMeData.credit_card.expire_month,
                      expireYear: usersMeData.credit_card.expire_year,
                      tailDigits: usersMeData.credit_card.tail_digits
                    } : undefined,
                    displayName: usersMeData.display_name,
                    email: usersMeData.email,
                    firstname: usersMeData.firstname,
                    id: usersMeData.id,
                    isEmailVerified: usersMeData.is_email_verified,
                    lastname: usersMeData.lastname,
                    phoneNumber: usersMeData.phone_number,
                    publicId: usersMeData.public_id
                  },
                  type: users/* Types.Me */.Y.Me
                });
              }

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref6.apply(this, arguments);
    };
  }();
}; // browserの戻るボタンなどでpopstateイベントが発生した時に、storeの状態を更新するフック
// next/routerのbeforePopStateはpathが同じ場合には実行されないため、windowに直接イベントリスナを設定
// https://github.com/vercel/next.js/blob/v12.0.1/packages/next/shared/lib/router/router.ts#L825-L833

var useWindowPopstate = function useWindowPopstate(_ref7) {
  var dispatch = _ref7.dispatch;
  (0,react.useEffect)(function () {
    var onWindowPopstateHandler = function onWindowPopstateHandler() {
      var payload = setup(history.state && history.state.options);

      if (payload) {
        dispatch({
          payload: payload,
          type: products_purchases/* Types.SetStep */.Y.SetStep
        });
      }
    };

    window.addEventListener('popstate', onWindowPopstateHandler);
    return function () {
      window.removeEventListener('popstate', onWindowPopstateHandler);
    };
  }, [dispatch]);
};
// EXTERNAL MODULE: ./src/components/layouts/BaseLayoutMerchantWithShortHeader.tsx + 1 modules
var BaseLayoutMerchantWithShortHeader = __webpack_require__(58750);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/molecules/merchant/products/purchases/PurchaseStep/PurchaseStep.module.scss
var PurchaseStep_module = __webpack_require__(41497);
var PurchaseStep_module_default = /*#__PURE__*/__webpack_require__.n(PurchaseStep_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/molecules/merchant/products/purchases/PurchaseStep/index.tsx







var getCss = function getCss(current, index) {
  var currentStyle = classnames_default()((PurchaseStep_module_default()).PurchaseStep__Item, (PurchaseStep_module_default()).isCurrent);
  var doneStyle = classnames_default()((PurchaseStep_module_default()).PurchaseStep__Item, (PurchaseStep_module_default()).isDone);
  var defaultStyle = classnames_default()((PurchaseStep_module_default()).PurchaseStep__Item);

  if (current === index) {
    return currentStyle;
  } else if (current > index) {
    return doneStyle;
  }

  return defaultStyle;
};

var StepItems;

(function (StepItems) {
  StepItems["Customer"] = "customer";
  StepItems["Payment"] = "payment";
  StepItems["Confirmation"] = "confirmation";
})(StepItems || (StepItems = {}));

var PurchaseStep = function PurchaseStep(_ref) {
  var allSteps = _ref.allSteps,
      current = _ref.current;
  var classes = classnames_default()((PurchaseStep_module_default()).PurchaseStep);
  var steps = allSteps.map(function (step, i) {
    return {
      css: getCss(current, i + 1),
      // NOTE: step starts with 1, in ModelTypeCourse.tsx
      label: "purchases.purchaseStep.".concat(step)
    };
  });
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: classes,
    children: steps.map(function (step, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
        className: step.css,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (PurchaseStep_module_default()).PurchaseStep__StepNumber,
          children: index + 1
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (PurchaseStep_module_default()).PurchaseStep__StepLabel,
          children: intl.formatMessage({
            id: step.label
          })
        })]
      }, index);
    })
  });
};

/* harmony default export */ var purchases_PurchaseStep = (PurchaseStep);
// EXTERNAL MODULE: ./src/hooks/useScrollToTop.ts
var useScrollToTop = __webpack_require__(60335);
// EXTERNAL MODULE: ./src/domain/entities/BookingPage.ts
var BookingPage = __webpack_require__(1885);
// EXTERNAL MODULE: ./src/molecules/merchant/common/cards/BookingPageCard/index.tsx
var BookingPageCard = __webpack_require__(17105);
// EXTERNAL MODULE: ./src/molecules/common/LabeledContainer/index.tsx
var LabeledContainer = __webpack_require__(88849);
// EXTERNAL MODULE: ./src/molecules/merchant/products/purchases/AvailableBookingPageList/AvailableBookingPageList.module.scss
var AvailableBookingPageList_module = __webpack_require__(58174);
var AvailableBookingPageList_module_default = /*#__PURE__*/__webpack_require__.n(AvailableBookingPageList_module);
;// CONCATENATED MODULE: ./src/molecules/merchant/products/purchases/AvailableBookingPageList/index.tsx









var tagsBy = function tagsBy(page) {
  var tags = [];

  if (page.tagNames.includes(BookingPage/* BookingPageTagName.Accepting */.Jk.Accepting)) {
    tags.push(BookingPage/* BookingPageTagName.Accepting */.Jk.Accepting);
  }

  return tags;
};

var AvailableBookingPageList = function AvailableBookingPageList(_ref) {
  var publicId = _ref.publicId,
      bookingPages = _ref.bookingPages;
  var intl = (0,useIntl/* default */.Z)();
  var classes = classnames_default()((AvailableBookingPageList_module_default()).AvailableBookingPageList);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LabeledContainer/* default */.Z, {
    className: classes,
    label: intl.formatMessage({
      id: "purchases.availableBookingPageList.title"
    }),
    paddingTop: true,
    children: bookingPages.map(function (page, i) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(BookingPageCard/* default */.Z, {
        className: (AvailableBookingPageList_module_default()).AvailableBookingPageList__BookingPageCard,
        title: page.name,
        description: page.descriptionText || '',
        url: "/".concat(publicId, "/").concat(page.publicId, "#pageContent"),
        thumbnailUrl: page.primaryImage && page.primaryImage.thumb ? page.primaryImage.thumb.url : '',
        tags: tagsBy(page)
      }, i);
    })
  });
};

/* harmony default export */ var purchases_AvailableBookingPageList = (AvailableBookingPageList);
// EXTERNAL MODULE: ./src/atoms/buttons/Button/index.tsx
var Button = __webpack_require__(48413);
// EXTERNAL MODULE: ./src/molecules/merchant/products/purchases/PurchaseBackToTop/PurchaseBackToTop.module.scss
var PurchaseBackToTop_module = __webpack_require__(67667);
var PurchaseBackToTop_module_default = /*#__PURE__*/__webpack_require__.n(PurchaseBackToTop_module);
;// CONCATENATED MODULE: ./src/molecules/merchant/products/purchases/PurchaseBackToTop/index.tsx







var PurchaseBackToTop = function PurchaseBackToTop(props) {
  var publicId = props.publicId;
  var intl = (0,useIntl/* default */.Z)();
  var classes = classnames_default()((PurchaseBackToTop_module_default()).PurchaseBackToTop);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classes,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
      isGhost: true,
      isFull: true,
      buttonSize: Button/* ButtonSize.Medium */.qE.Medium,
      href: "/".concat(publicId),
      children: intl.formatMessage({
        id: 'purchases.purchaseBackToTop.submitButton'
      })
    })
  });
};

/* harmony default export */ var purchases_PurchaseBackToTop = (PurchaseBackToTop);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/date-fns/index.js
var date_fns = __webpack_require__(47292);
// EXTERNAL MODULE: ./node_modules/luxon/build/cjs-browser/luxon.js
var luxon = __webpack_require__(99490);
// EXTERNAL MODULE: ./src/molecules/merchant/products/purchases/PurchaseItemList/PurchaseItemList.module.scss
var PurchaseItemList_module = __webpack_require__(85343);
var PurchaseItemList_module_default = /*#__PURE__*/__webpack_require__.n(PurchaseItemList_module);
;// CONCATENATED MODULE: ./src/molecules/merchant/products/purchases/PurchaseItemList/PurchaseItemProfile/index.tsx








var PurchaseItemProfile = function PurchaseItemProfile(props) {
  var publishedAt = luxon/* DateTime.local */.ou.local().toString();
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    children: props.productUrl ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      className: (PurchaseItemList_module_default()).PurchaseItemList__Link,
      href: props.productUrl,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (PurchaseItemList_module_default()).PurchaseItemList__Inner,
        children: [props.productImage ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__Image,
          src: props.productImage,
          alt: props.productName
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__Image
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__Name,
          children: [props.productName, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (PurchaseItemList_module_default()).PurchaseItemList__Id,
            children: props.merchantId
          })]
        }), props.schemeType === 'subscription' && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__AdmissionDate,
          children: [intl.formatMessage({
            id: 'common.dateOfSubscription'
          }), "\uFF1A", intl.formatDate((0,date_fns.format)(publishedAt), {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'short'
          })]
        })]
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (PurchaseItemList_module_default()).PurchaseItemList__Inner,
      children: [props.productImage ? /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
        className: (PurchaseItemList_module_default()).PurchaseItemList__Image,
        src: props.productImage,
        alt: props.productName
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (PurchaseItemList_module_default()).PurchaseItemList__Image
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__Name,
          children: [props.productName, /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (PurchaseItemList_module_default()).PurchaseItemList__Id,
            children: props.merchantId
          })]
        }), props.schemeType === 'subscription' && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__AdmissionDate,
          children: [intl.formatMessage({
            id: 'common.dateOfSubscription'
          }), "\uFF1A", intl.formatDate((0,date_fns.format)(publishedAt), {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'short'
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var PurchaseItemList_PurchaseItemProfile = (PurchaseItemProfile);
;// CONCATENATED MODULE: ./src/molecules/merchant/products/purchases/PurchaseTicketBookItemList/index.tsx

var _excluded = ["ticketCount", "price", "expiryDate", "productUrl"];










var PurchaseTicketBookItemList = function PurchaseTicketBookItemList(_ref) {
  var ticketCount = _ref.ticketCount,
      price = _ref.price,
      expiryDate = _ref.expiryDate,
      productUrl = _ref.productUrl,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var classes = classnames_default()((PurchaseItemList_module_default()).PurchaseItemList);
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LabeledContainer/* default */.Z, {
    label: intl.formatMessage({
      id: "purchases.purchaseItemList.title.ticketBook"
    }),
    paddingTop: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classes,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PurchaseItemList_PurchaseItemProfile, {
        productImage: props.productImage,
        productName: props.productName,
        merchantId: props.merchantId,
        productUrl: productUrl,
        schemeType: "ticketBook"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
        className: (PurchaseItemList_module_default()).PurchaseItemList__List,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListTitle,
          children: intl.formatMessage({
            id: 'common.totalPrice'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListData,
          "data-style": "price",
          children: intl.formatMessage({
            id: 'common.price'
          }, {
            price: intl.formatNumber(price)
          })
        })]
      }), ticketCount && /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
        className: (PurchaseItemList_module_default()).PurchaseItemList__List,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListTitle,
          children: intl.formatMessage({
            id: 'common.validCount'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListData,
          "data-style": "table-child",
          children: intl.formatMessage({
            id: 'common.ticketCount'
          }, {
            ticketCount: intl.formatNumber(ticketCount)
          })
        })]
      }), expiryDate && /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
        className: (PurchaseItemList_module_default()).PurchaseItemList__List,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListTitle,
          children: intl.formatMessage({
            id: 'common.expiryDate'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListData,
          "data-style": "table-child",
          children: intl.formatDate((0,date_fns.format)(expiryDate), {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'short'
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
        className: (PurchaseItemList_module_default()).PurchaseItemList__List,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListTitle,
          children: intl.formatMessage({
            id: 'common.paymentMethod'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListData,
          "data-style": "table-child",
          children: intl.formatMessage({
            id: 'common.creditCard'
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var purchases_PurchaseTicketBookItemList = (PurchaseTicketBookItemList);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/molecules/merchant/products/purchases/PurchaseSubscriptionItemList/index.tsx












var PurchaseSubscriptionItemList = function PurchaseSubscriptionItemList(_ref) {
  var productImage = _ref.productImage,
      merchantId = _ref.merchantId,
      productName = _ref.productName,
      waitFirstAnchor = _ref.waitFirstAnchor,
      firstCharge = _ref.firstCharge,
      price = _ref.price,
      productUrl = _ref.productUrl,
      availableMonthsPeriod = _ref.availableMonthsPeriod;
  var classes = classnames_default()((PurchaseItemList_module_default()).PurchaseItemList);
  var publishedAt = luxon/* DateTime.local */.ou.local().toString();
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LabeledContainer/* default */.Z, {
    label: intl.formatMessage({
      id: "purchases.purchaseItemList.title.subscription"
    }),
    paddingTop: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: classes,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PurchaseItemList_PurchaseItemProfile, {
        productImage: productImage,
        productName: productName,
        merchantId: merchantId,
        productUrl: productUrl,
        schemeType: "subscription"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
        className: (PurchaseItemList_module_default()).PurchaseItemList__List,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListTitle,
          children: intl.formatMessage({
            id: 'common.monthlyAmount'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListData,
          "data-style": "price",
          children: intl.formatMessage({
            id: 'common.price'
          }, {
            price: intl.formatNumber(price)
          })
        })]
      }), firstCharge !== null && !waitFirstAnchor && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__List,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
            className: (PurchaseItemList_module_default()).PurchaseItemList__ListTitle,
            children: intl.formatMessage({
              id: 'common.paymentDetail.paymentForCurrentMonth'
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("dd", {
            className: (PurchaseItemList_module_default()).PurchaseItemList__ListData,
            "data-style": "table-child",
            children: [!firstCharge.is_first_charge_pro_rata_basis ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: intl.formatMessage({
                id: 'common.price'
              }, {
                price: intl.formatNumber(price)
              })
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: intl.formatMessage({
                id: 'common.price'
              }, {
                price: intl.formatNumber(firstCharge.amount_user_will_pay)
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (PurchaseItemList_module_default()).PurchaseItemList__Explanation,
              children: !firstCharge.is_first_charge_pro_rata_basis ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: intl.formatMessage({
                  id: 'common.purchaseExplanation.purchaseNowWithDailyRate'
                })
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                children: intl.formatMessage({
                  id: 'common.purchaseExplanation.purchaseNowWithoutDailyRate'
                })
              })
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__List,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
            className: (PurchaseItemList_module_default()).PurchaseItemList__ListTitle,
            children: intl.formatMessage({
              id: 'common.paymentDetail.paymentDateForCurrentMonth'
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
            className: (PurchaseItemList_module_default()).PurchaseItemList__ListData,
            "data-style": "table-child",
            children: intl.formatDate((0,date_fns.format)(publishedAt), {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              weekday: 'short'
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
        className: (PurchaseItemList_module_default()).PurchaseItemList__List,
        children: [!waitFirstAnchor ? /*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListTitle,
          children: intl.formatMessage({
            id: 'common.paymentDetail.paymentDateFromNextMonth'
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListTitle,
          children: intl.formatMessage({
            id: 'common.paymentDate'
          })
        }), waitFirstAnchor ? /*#__PURE__*/(0,jsx_runtime.jsxs)("dd", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListData,
          "data-style": "table-child",
          children: [intl.formatMessage({
            id: 'common.paymentDetail.firstDayOfEveryMonth'
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (PurchaseItemList_module_default()).PurchaseItemList__Explanation,
            children: intl.formatMessage({
              id: 'common.purchaseExplanation.purchaseTheNextMonth'
            })
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListData,
          "data-style": "table-child",
          children: intl.formatMessage({
            id: 'common.paymentDetail.firstDayOfEveryMonth'
          })
        })]
      }), availableMonthsPeriod && /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
        className: (PurchaseItemList_module_default()).PurchaseItemList__List,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListTitle,
          children: intl.formatMessage({
            id: 'common.availableMonthsPeriod'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListData,
          "data-style": "table-child",
          children: dayjs_min_default()().tz('Asia/Tokyo').add(availableMonthsPeriod, 'month').endOf('month').format('YYYY年M月D日')
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("dl", {
        className: (PurchaseItemList_module_default()).PurchaseItemList__List,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("dt", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListTitle,
          children: intl.formatMessage({
            id: 'common.paymentMethod'
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("dd", {
          className: (PurchaseItemList_module_default()).PurchaseItemList__ListData,
          "data-style": "table-child",
          children: intl.formatMessage({
            id: 'common.creditCard'
          })
        })]
      })]
    })
  });
};

/* harmony default export */ var purchases_PurchaseSubscriptionItemList = (PurchaseSubscriptionItemList);
// EXTERNAL MODULE: ./src/molecules/merchant/products/purchases/PurchaseVerifyUserAlert/PurchaseVerifyUserAlert.module.scss
var PurchaseVerifyUserAlert_module = __webpack_require__(28368);
var PurchaseVerifyUserAlert_module_default = /*#__PURE__*/__webpack_require__.n(PurchaseVerifyUserAlert_module);
;// CONCATENATED MODULE: ./src/molecules/merchant/products/purchases/PurchaseVerifyUserAlert/index.tsx












var PurchaseVerifyUserAlert = function PurchaseVerifyUserAlert(props) {
  var labelType = props.labelType;
  var intl = (0,useIntl/* default */.Z)();

  var _useState = (0,react.useState)(false),
      submitted = _useState[0],
      setSubmitted = _useState[1];

  var handleSubmit = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return secured_axios/* default.get */.ZP.get("".concat((0,infrastructure_api/* apiRoot */.bI)(), "/users/send_verification"));

          case 3:
            setSubmitted(true);
            _context.next = 8;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  })), []);
  var classes = classnames_default()((PurchaseVerifyUserAlert_module_default()).PurchaseVerifyUserAlert);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (PurchaseVerifyUserAlert_module_default()).PurchaseVerifyUserAlert__Title,
      children: intl.formatMessage({
        id: 'purchases.purchaseVerifyUserAlert.title'
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (PurchaseVerifyUserAlert_module_default()).PurchaseVerifyUserAlert__Description,
      children: intl.formatMessage({
        id: "purchases.purchaseVerifyUserAlert.description.".concat(labelType)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
      isFull: true,
      disabled: submitted,
      buttonSize: Button/* ButtonSize.Medium */.qE.Medium,
      onClick: handleSubmit,
      children: intl.formatMessage({
        id: "purchases.purchaseVerifyUserAlert.submitButton.".concat(submitted ? 'submitted' : 'submit')
      })
    })]
  });
};

/* harmony default export */ var purchases_PurchaseVerifyUserAlert = (PurchaseVerifyUserAlert);
// EXTERNAL MODULE: ./src/molecules/merchant/products/purchases/PurchaseCompleteAlert/PurchaseCompleteAlert.module.scss
var PurchaseCompleteAlert_module = __webpack_require__(51390);
var PurchaseCompleteAlert_module_default = /*#__PURE__*/__webpack_require__.n(PurchaseCompleteAlert_module);
;// CONCATENATED MODULE: ./src/molecules/merchant/products/purchases/PurchaseCompleteAlert/index.tsx







var PurchaseCompleteAlert = function PurchaseCompleteAlert(_ref) {
  var labelType = _ref.labelType;
  var intl = (0,useIntl/* default */.Z)();
  var classes = classnames_default()((PurchaseCompleteAlert_module_default()).PurchaseCompleteAlert);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (PurchaseCompleteAlert_module_default()).PurchaseCompleteAlert__Title,
      children: intl.formatMessage({
        id: "purchases.purchaseCompleteAlert.title.".concat(labelType)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (PurchaseCompleteAlert_module_default()).PurchaseCompleteAlert__Text,
      children: intl.formatMessage({
        id: "purchases.purchaseCompleteAlert.message1.".concat(labelType)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (PurchaseCompleteAlert_module_default()).PurchaseCompleteAlert__Text,
      children: intl.formatMessage({
        id: "purchases.purchaseCompleteAlert.message2.".concat(labelType)
      })
    })]
  });
};

/* harmony default export */ var purchases_PurchaseCompleteAlert = (PurchaseCompleteAlert);
// EXTERNAL MODULE: ./src/hooks/gtm/index.ts
var gtm = __webpack_require__(51295);
;// CONCATENATED MODULE: ./src/molecules/merchant/products/purchases/Completion/index.tsx














var Completion = function Completion(props) {
  (0,useScrollToTop/* useScrollToTop */.Z)();
  var schemeType = props.schemeType,
      product = props.product,
      firstCharge = props.firstCharge,
      _props$settings = props.settings,
      bookingPages = _props$settings.bookingPages,
      expiryDate = _props$settings.expiryDate,
      verifiedUser = _props$settings.verifiedUser,
      customerPublicId = _props$settings.customerPublicId,
      publicId = props.publicId; // Fire GTM booking_completion event

  (0,gtm/* usePushPurchaseEventToDataLayer */.U)({
    productId: product.publicId,
    customerId: customerPublicId
  });
  var labelType = schemeType === purchases/* SchemeType.Subscription */.Yr.Subscription ? 'subscription' : 'ticketBook';
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(purchases_PurchaseCompleteAlert, {
      labelType: labelType
    }), !verifiedUser && /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_PurchaseVerifyUserAlert, {
      labelType: labelType
    }), schemeType === purchases/* SchemeType.TicketBook */.Yr.TicketBook && /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_PurchaseTicketBookItemList, {
      productImage: product.image ? product.image.thumb && product.image.thumb.url : '',
      productName: product.name,
      merchantId: props.publicId,
      ticketCount: product.ticketCount,
      price: product.price,
      expiryDate: expiryDate
    }), schemeType === purchases/* SchemeType.Subscription */.Yr.Subscription && /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_PurchaseSubscriptionItemList, {
      productImage: product.image ? product.image.thumb && product.image.thumb.url : '',
      productName: product.name,
      merchantId: props.publicId,
      waitFirstAnchor: product.waitFirstAnchor,
      firstCharge: firstCharge,
      price: product.price,
      availableMonthsPeriod: product.availableMonthsPeriod
    }), bookingPages.length !== 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_AvailableBookingPageList, {
      publicId: publicId,
      bookingPages: bookingPages
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_PurchaseBackToTop, {
      publicId: publicId
    })]
  });
};

/* harmony default export */ var purchases_Completion = (Completion);
// EXTERNAL MODULE: ./src/hooks/redux.ts
var redux = __webpack_require__(14618);
;// CONCATENATED MODULE: ./src/redux/selectors/merchants/products/purchases/inputs.ts
var getInputs = function getInputs(state) {
  return state;
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(10748);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(81531);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(63553);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(37247);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(92777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(82262);
;// CONCATENATED MODULE: ./src/redux/actions/merchants/products/purchases/inputs.ts









function inputs_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function inputs_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? inputs_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : inputs_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,getPrototypeOf/* default */.Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,getPrototypeOf/* default */.Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,possibleConstructorReturn/* default */.Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }








var PurchasingError = /*#__PURE__*/function () {
  function PurchasingError(message) {
    (0,classCallCheck/* default */.Z)(this, PurchasingError);

    this.message = message;

    (0,defineProperty/* default */.Z)(this, "name", 'PurchasingError');
  }

  (0,createClass/* default */.Z)(PurchasingError, [{
    key: "toString",
    value: function toString() {
      return this.name + ': ' + this.message;
    }
  }]);

  return PurchasingError;
}();

var RestartError = /*#__PURE__*/function (_PurchasingError) {
  (0,inherits/* default */.Z)(RestartError, _PurchasingError);

  var _super = _createSuper(RestartError);

  function RestartError() {
    var _this;

    (0,classCallCheck/* default */.Z)(this, RestartError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "name", 'RestartError');

    return _this;
  }

  return (0,createClass/* default */.Z)(RestartError);
}(PurchasingError);
var ReturnTargetStepError = /*#__PURE__*/function (_PurchasingError2) {
  (0,inherits/* default */.Z)(ReturnTargetStepError, _PurchasingError2);

  var _super2 = _createSuper(ReturnTargetStepError);

  function ReturnTargetStepError() {
    var _this2;

    (0,classCallCheck/* default */.Z)(this, ReturnTargetStepError);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this2), "name", 'ReturnTargetStepError');

    return _this2;
  }

  return (0,createClass/* default */.Z)(ReturnTargetStepError);
}(PurchasingError);
var inputPurchasingConfirmation = function inputPurchasingConfirmation(schemeType, productId, inputs) {
  return /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(dispatch) {
      var res, customFields;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch({
                payload: {
                  postable: false
                },
                type: products_purchases/* Types.SetPostable */.Y.SetPostable
              });
              _context.next = 3;
              return postPurchasingFinish(schemeType, productId, inputs);

            case 3:
              res = _context.sent;

              if (!(!res.success && res.errors && res.errors.customer_custom_fields)) {
                _context.next = 12;
                break;
              }

              _context.next = 7;
              return fetchCustomFields(productId);

            case 7:
              customFields = _context.sent;
              dispatch({
                payload: {
                  customFields: customFields,
                  errors: res.errors.customer_custom_fields
                },
                type: products_purchases/* Types.SetCustomFieldsAndErrors */.Y.SetCustomFieldsAndErrors
              });
              dispatch({
                payload: {
                  errors: [purchases/* EntireErrorType.CustomerFailed */.oX.CustomerFailed]
                },
                type: products_purchases/* Types.SetEntireErrors */.Y.SetEntireErrors
              });
              dispatch({
                payload: {
                  postable: true
                },
                type: products_purchases/* Types.SetPostable */.Y.SetPostable
              });
              throw new ReturnTargetStepError('post api failed : customer_custom_fields');

            case 12:
              if (!(!res.success && res.errors && res.errors.payment_method)) {
                _context.next = 16;
                break;
              }

              dispatch({
                payload: {
                  errors: [purchases/* EntireErrorType.PaymentFailed */.oX.PaymentFailed]
                },
                type: products_purchases/* Types.SetEntireErrors */.Y.SetEntireErrors
              });
              dispatch({
                payload: {
                  postable: true
                },
                type: products_purchases/* Types.SetPostable */.Y.SetPostable
              });
              throw new ReturnTargetStepError('post api failed : payment_method');

            case 16:
              if (!(!res.success && res.errors && res.errors.jcb_brand_disabled)) {
                _context.next = 20;
                break;
              }

              dispatch({
                payload: {
                  errors: [purchases/* EntireErrorType.JCBBrandDisabled */.oX.JCBBrandDisabled]
                },
                type: products_purchases/* Types.SetEntireErrors */.Y.SetEntireErrors
              });
              dispatch({
                payload: {
                  postable: true
                },
                type: products_purchases/* Types.SetPostable */.Y.SetPostable
              });
              throw new ReturnTargetStepError('post api failed : jcb_brand_disabled');

            case 20:
              if (res.success) {
                _context.next = 24;
                break;
              }

              dispatch({
                payload: {
                  errors: [purchases/* EntireErrorType.Unexpected */.oX.Unexpected]
                },
                type: products_purchases/* Types.SetEntireErrors */.Y.SetEntireErrors
              });
              dispatch({
                payload: {
                  postable: true
                },
                type: products_purchases/* Types.SetPostable */.Y.SetPostable
              });
              throw new RestartError('post api failed : unexpected');

            case 24:
              dispatch({
                payload: {
                  verifiedUser: !!res.verified_user,
                  customer: res.customer
                },
                type: products_purchases/* Types.SetPurchasedUser */.Y.SetPurchasedUser
              });
              dispatch({
                payload: {
                  lastOrder: res.last_order
                },
                type: products_purchases/* Types.SetLastOrder */.Y.SetLastOrder
              });
              dispatch({
                payload: {
                  postable: true
                },
                type: products_purchases/* Types.SetPostable */.Y.SetPostable
              });

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var inputPurchasingPayment = function inputPurchasingPayment(schemeType, productId, payment, merchantPublicId) {
  return /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(dispatch) {
      var merchant, stripeResponse, res, token;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              dispatch({
                payload: {
                  postable: false
                },
                type: products_purchases/* Types.SetPostable */.Y.SetPostable
              });
              _context2.next = 3;
              return secured_axios/* default.get */.ZP.get("".concat((0,infrastructure_api/* apiRoot */.bI)(), "/merchants/").concat(merchantPublicId));

            case 3:
              merchant = _context2.sent;
              _context2.next = 6;
              return postStripe(payment, merchant.data.jcb_enabled);

            case 6:
              stripeResponse = _context2.sent;

              if (!(stripeResponse && stripeResponse.error)) {
                _context2.next = 11;
                break;
              }

              dispatch({
                payload: {
                  postable: true
                },
                type: products_purchases/* Types.SetPostable */.Y.SetPostable
              });
              dispatch({
                payload: {
                  errors: stripeResponse.error
                },
                type: products_purchases/* Types.SetStripeErrors */.Y.SetStripeErrors
              });
              throw new Error('postPayment failed');

            case 11:
              _context2.next = 13;
              return postPurchasingPayment(schemeType, productId, {
                payment: payment
              });

            case 13:
              res = _context2.sent;
              dispatch({
                payload: {
                  postable: true
                },
                type: products_purchases/* Types.SetPostable */.Y.SetPostable
              });

              if (res.success) {
                _context2.next = 17;
                break;
              }

              throw new Error('post api failed');

            case 17:
              token = stripeResponse && stripeResponse.token;
              dispatch({
                payload: {
                  payment: inputs_objectSpread(inputs_objectSpread({}, payment), {}, {
                    token: token
                  })
                },
                type: inputs/* Types.InputPayment */.Y.InputPayment
              });

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var fieldCheck = function fieldCheck(userInfo, errors) {
  var fieldIds = Object.keys(userInfo.customerFields);
  var errorFieldIds = Object.keys(errors.customer_custom_fields);
  return errorFieldIds.every(function (id) {
    return fieldIds.includes(id);
  });
};

var inputPurchasingUserInfo = function inputPurchasingUserInfo(schemeType, productId, userInfo) {
  return /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(dispatch) {
      var res, customFields;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch({
                payload: {
                  postable: false
                },
                type: products_purchases/* Types.SetPostable */.Y.SetPostable
              });
              _context3.next = 3;
              return postPurchasingCustomer(schemeType, productId, {
                userInfo: userInfo
              });

            case 3:
              res = _context3.sent;
              dispatch({
                payload: {
                  postable: true
                },
                type: products_purchases/* Types.SetPostable */.Y.SetPostable
              });

              if (res.success) {
                _context3.next = 15;
                break;
              }

              if (!fieldCheck(userInfo, res.errors)) {
                _context3.next = 10;
                break;
              }

              dispatch({
                payload: {
                  errors: res.errors.customer_custom_fields
                },
                type: products_purchases/* Types.SetCustomerErrors */.Y.SetCustomerErrors
              });
              _context3.next = 14;
              break;

            case 10:
              _context3.next = 12;
              return fetchCustomFields(productId);

            case 12:
              customFields = _context3.sent;
              dispatch({
                payload: {
                  customFields: customFields,
                  errors: res.errors.customer_custom_fields
                },
                type: products_purchases/* Types.SetCustomFieldsAndErrors */.Y.SetCustomFieldsAndErrors
              });

            case 14:
              throw new Error('post api failed');

            case 15:
              dispatch({
                payload: {
                  userInfo: userInfo
                },
                type: inputs/* Types.InputUserInfo */.Y.InputUserInfo
              });

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var clearCustomerError = function clearCustomerError(name) {
  return function (dispatch) {
    if (name.indexOf('customerFields') !== -1) {
      var id = Number(name.replace('customerFields.', ''));
      dispatch({
        payload: {
          id: id
        },
        type: products_purchases/* Types.ClearCustomerError */.Y.ClearCustomerError
      });
    }
  };
};
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/organisms/merchants/products/purchases/Confirmation/components/PurchaseConfirmAlert/PurchaseConfirmAlert.module.scss
var PurchaseConfirmAlert_module = __webpack_require__(10068);
var PurchaseConfirmAlert_module_default = /*#__PURE__*/__webpack_require__.n(PurchaseConfirmAlert_module);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/Confirmation/components/PurchaseConfirmAlert/index.tsx








var PurchaseConfirmAlert = function PurchaseConfirmAlert(_ref) {
  var labelType = _ref.labelType,
      termsUrl = _ref.termsUrl,
      lawUrl = _ref.lawUrl;
  var classes = classnames_default()((PurchaseConfirmAlert_module_default()).PurchaseConfirmAlert);
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      className: "".concat((PurchaseConfirmAlert_module_default()).PurchaseConfirmAlert__Paragraph, " ").concat((PurchaseConfirmAlert_module_default()).isBold),
      children: [intl.formatMessage({
        id: "purchases.purchaseConfirmAlert.message1.".concat(labelType)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: (PurchaseConfirmAlert_module_default()).PurchaseConfirmAlert__Em,
        children: intl.formatMessage({
          id: "purchases.purchaseConfirmAlert.message2.".concat(labelType)
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      className: (PurchaseConfirmAlert_module_default()).PurchaseConfirmAlert__Paragraph,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "purchases.purchaseConfirmAlert.message3.".concat(labelType),
        values: {
          terms: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: termsUrl,
            prefetch: false,
            className: (PurchaseConfirmAlert_module_default()).PurchaseConfirmAlert__Link,
            target: "_blank",
            rel: "noopener noreferrer",
            children: intl.formatMessage({
              id: 'purchases.purchaseConfirmAlert.termOfUse'
            })
          })
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "purchases.purchaseConfirmAlert.message4.announceForSpecifiedCommercialTransactionsLaw",
        values: {
          law: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: lawUrl,
            prefetch: false,
            className: (PurchaseConfirmAlert_module_default()).PurchaseConfirmAlert__Link,
            target: "_blank",
            rel: "noopener noreferrer",
            children: intl.formatMessage({
              id: 'purchases.purchaseConfirmAlert.specifiedCommercialTransactionsLaw'
            })
          })
        }
      })]
    })]
  });
};

/* harmony default export */ var components_PurchaseConfirmAlert = (PurchaseConfirmAlert);
// EXTERNAL MODULE: ./src/redux/index.ts + 9 modules
var src_redux = __webpack_require__(74883);
// EXTERNAL MODULE: ./src/reservation-page/RSButton/index.tsx
var RSButton = __webpack_require__(17940);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/Confirmation/index.tsx


















var InputConfirmation = function InputConfirmation(props) {
  var dispatch = (0,src_redux/* useAppDispatch */.TL)();
  (0,react.useEffect)(function () {
    (0,useScrollToTop/* scrollToTop */.k)();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var useSelector = function useSelector() {
    return (0,redux/* useShallowEqualSelector */.M)(function (state) {
      return {
        inputs: getInputs(state.merchantsProductsPurchasesInputs)
      };
    });
  };

  var _useSelector = useSelector(),
      inputs = _useSelector.inputs;

  var handleSubmit = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var schemeType, onSubmit, onRestart, onReturnTargetStep;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            schemeType = props.schemeType, onSubmit = props.onSubmit, onRestart = props.onRestart, onReturnTargetStep = props.onReturnTargetStep;
            _context.prev = 1;
            _context.next = 4;
            return dispatch(inputPurchasingConfirmation(schemeType, inputs.productId, inputs));

          case 4:
            onSubmit();
            _context.next = 11;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);

            if (_context.t0 instanceof ReturnTargetStepError) {
              onReturnTargetStep();
            }

            if (_context.t0 instanceof RestartError) {
              onRestart();
            }

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7]]);
  })), [dispatch, props, inputs]);
  var product = props.product,
      settings = props.settings,
      postable = props.postable,
      schemeType = props.schemeType;
  var intl = (0,useIntl/* default */.Z)();
  var labelType = schemeType === purchases/* SchemeType.Subscription */.Yr.Subscription ? 'subscription' : 'ticketBook';
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_PurchaseConfirmAlert, {
      labelType: labelType,
      termsUrl: "/user_terms",
      lawUrl: "/".concat(props.publicId, "/legal_notice")
    }), schemeType === purchases/* SchemeType.TicketBook */.Yr.TicketBook && /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_PurchaseTicketBookItemList, {
      productImage: product.image ? product.image.thumb && product.image.thumb.url : '',
      productName: product.name,
      merchantId: props.publicId,
      ticketCount: product.ticketCount,
      price: product.price,
      expiryDate: settings.expiryDate
    }), schemeType === purchases/* SchemeType.Subscription */.Yr.Subscription && /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_PurchaseSubscriptionItemList, {
      productImage: product.image ? product.image.thumb && product.image.thumb.url : '',
      productName: product.name,
      merchantId: props.publicId,
      waitFirstAnchor: product.waitFirstAnchor,
      firstCharge: props.firstCharge,
      price: product.price,
      availableMonthsPeriod: product.availableMonthsPeriod
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "px-[18px] py-5",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RSButton/* RSButton */.F, {
        variant: "basic",
        isBlock: true,
        isLoading: !postable,
        disabled: !postable,
        value: intl.formatMessage({
          id: "purchases.inputConfirmation.submitButton.".concat(labelType)
        }),
        onClick: handleSubmit,
        children: intl.formatMessage({
          id: "purchases.inputConfirmation.submitButton.".concat(labelType)
        })
      })
    })]
  });
};

/* harmony default export */ var Confirmation = (InputConfirmation);
;// CONCATENATED MODULE: ./src/helpers/merchants/products/purchases/helper.tsx


function helper_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function helper_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? helper_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : helper_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var finder = function finder(name) {
  return name.replace(/\[(\w+)\]/g, '.$1').replace(/^\./, '').split('.');
};

var bindDown = function bindDown(key, obj) {
  var found = key in obj ? obj[key] : {};
  found = Array.isArray(found) ? Object.values(helper_objectSpread({}, found)) : helper_objectSpread({}, found);
  obj[key] = found;
  return found;
};

var changeObjectByNestedString = function changeObjectByNestedString(obj, name, value) {
  // nameのstringでvalueをupdateする。
  // nameは `me.firstname` とか `options[0].description` とかで指定できる
  var names = finder(name);

  var newObj = helper_objectSpread({}, obj);

  var found = newObj;

  for (var i = 0, n = names.length; i < n; ++i) {
    var key = names[i];

    if (i === n - 1) {
      // last
      found[key] = value;
      break;
    }

    found = bindDown(key, found);

    if (i === 0) {
      // first
      newObj[key] = found;
    }
  }

  return newObj;
}; // tslint:disable-next-line: no-any

var getValueByNestedString = function getValueByNestedString(obj, name) {
  var names = finder(name);
  var found = obj;

  for (var i = 0, n = names.length; i < n; ++i) {
    var key = names[i];

    if (i === n - 1) {
      // last
      return found[key];
    }

    found = key in found ? found[key] : {};
  }

  return undefined;
};
function radioBehaviorByCheckbox(mode, checked, elements, newElement) {
  if (mode === 'single') {
    return checked ? [newElement] : [];
  }

  checked ? elements.push(newElement) : remove(elements, function (e) {
    return e.id === newElement.id;
  });
  return elements;
}
;// CONCATENATED MODULE: ./src/interfaces/merchants/products/purchases/custom_fields/index.ts
var InputType;

(function (InputType) {
  InputType["TextField"] = "text_field";
  InputType["TextArea"] = "text_area";
  InputType["SelectBox"] = "select_box";
  InputType["RadioButton"] = "radio_button";
})(InputType || (InputType = {}));

var ValidationType;

(function (ValidationType) {
  ValidationType["None"] = "none";
  ValidationType["Alphanumeric"] = "alphanumeric";
  ValidationType["Numeric"] = "numeric";
  ValidationType["Phone"] = "phone";
  ValidationType["Email"] = "email";
  ValidationType["Katakana"] = "katakana";
})(ValidationType || (ValidationType = {}));
// EXTERNAL MODULE: ./src/atoms/CheckInput/index.tsx
var CheckInput = __webpack_require__(37650);
// EXTERNAL MODULE: ./src/atoms/Select/index.tsx
var Select = __webpack_require__(94447);
// EXTERNAL MODULE: ./src/atoms/TextInput/index.tsx
var TextInput = __webpack_require__(33668);
// EXTERNAL MODULE: ./src/atoms/FormErrorMessage/index.tsx
var FormErrorMessage = __webpack_require__(77362);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/Customer/components/ErrorMessage/index.tsx


var _ERROR_COMPONENTS;






var ErrorType;

(function (ErrorType) {
  ErrorType["Blank"] = "blank";
  ErrorType["Invalid"] = "invalid";
  ErrorType["NotSupportValue"] = "not_support_value";
  ErrorType["TooLong"] = "too_long";
})(ErrorType || (ErrorType = {}));

var BlankMessage = function BlankMessage() {
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
    children: intl.formatMessage({
      id: "purchases.errors.customer.blank",
      defaultMessage: intl.formatMessage({
        id: 'purchases.errors.blank'
      })
    })
  });
};

var InvalidMessage = function InvalidMessage() {
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
    children: intl.formatMessage({
      id: "purchases.errors.customer.invalid",
      defaultMessage: intl.formatMessage({
        id: 'purchases.errors.invalid'
      })
    })
  });
};

var NotSupportValueMessage = function NotSupportValueMessage() {
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
    children: intl.formatMessage({
      id: "purchases.errors.customer.not_support_value",
      defaultMessage: intl.formatMessage({
        id: 'purchases.errors.not_support_value'
      })
    })
  });
};

var TooLongMessage = function TooLongMessage() {
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
    children: intl.formatMessage({
      id: "purchases.errors.customer.too_long",
      defaultMessage: intl.formatMessage({
        id: 'purchases.errors.too_long'
      })
    })
  });
};

var ERROR_COMPONENTS = (_ERROR_COMPONENTS = {}, (0,defineProperty/* default */.Z)(_ERROR_COMPONENTS, ErrorType.Blank, BlankMessage), (0,defineProperty/* default */.Z)(_ERROR_COMPONENTS, ErrorType.Invalid, InvalidMessage), (0,defineProperty/* default */.Z)(_ERROR_COMPONENTS, ErrorType.NotSupportValue, NotSupportValueMessage), (0,defineProperty/* default */.Z)(_ERROR_COMPONENTS, ErrorType.TooLong, TooLongMessage), _ERROR_COMPONENTS);

var ErrorMessage = function ErrorMessage(_ref) {
  var errors = _ref.errors;
  if (!errors) return null;
  if (errors.length === 0) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: errors.map(function (error, index) {
      var Component = ERROR_COMPONENTS[error];
      if (!Component) return null;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {}, index);
    })
  });
};

/* harmony default export */ var components_ErrorMessage = (ErrorMessage);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/Customer/components/CustomerField/index.tsx












var textValueCorrection = function textValueCorrection(field, value) {
  switch (field.validationType) {
    case ValidationType.Alphanumeric:
      return value.replace(/[^0-9a-zA-Zａ-ｚＡ-Ｚ０-９]+/i, '');

    case ValidationType.Numeric:
      return value.replace(/[^0-9０-９]+/i, '');

    case ValidationType.Phone:
      return value.replace(/[０-９]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 65248);
      }).replace(/[‐－―ー]/g, '-').replace(/[^\d\-]/g, '').substr(0, 20);

    case ValidationType.Email:
      return value.replace(/[！-～]/g, function (s) {
        return String.fromCharCode(s.charCodeAt(0) - 65248);
      }).substr(0, 100);

    default:
      return value;
  }
};

var inputValidation = function inputValidation(field, value) {
  if (field.inputType === InputType.TextField) {
    return textValueCorrection(field, value).substr(0, 1000);
  } else {
    return value.substr(0, 1000);
  }
};

var CustomerField_submittable = function submittable(customerFields, values) {
  return customerFields.every(function (f) {
    return !f.required || f.required && !!values[f.id];
  });
};
var createInitialState = function createInitialState(customerFields) {
  if (!customerFields) {
    return {};
  }

  return customerFields.reduce(function (acc, field) {
    acc[field.id] = field.defaultValue || '';
    return acc;
  }, {});
};

var toLabel = function toLabel(field, intl) {
  if (field.inputType !== InputType.TextField) {
    return field.label;
  }

  switch (field.validationType) {
    case ValidationType.Alphanumeric:
      return "".concat(field.label, " (").concat(intl.formatMessage({
        id: "purchases.validationLabel.alphanumeric"
      }), ")");

    case ValidationType.Numeric:
      return "".concat(field.label, " (").concat(intl.formatMessage({
        id: "purchases.validationLabel.numeric"
      }), ")");

    case ValidationType.Katakana:
      return "".concat(field.label, " (").concat(intl.formatMessage({
        id: "purchases.validationLabel.katakana"
      }), ")");

    default:
      return field.label;
  }
};

var CustomerFields = function CustomerFields(props) {
  var values = props.values,
      customerFields = props.customerFields;
  var intl = (0,useIntl/* default */.Z)();
  var handleChange = (0,react.useCallback)(function (e, field) {
    var value = e.currentTarget.value;
    var namePrefix = props.namePrefix,
        onChange = props.onChange;
    var applyValue = inputValidation(field, value);
    onChange("".concat(namePrefix, ".").concat(field.id), applyValue);
  }, [props]);
  var renderInput = (0,react.useCallback)(function (field) {
    switch (field.inputType) {
      case InputType.TextField:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
          type: TextInput/* TextInputType.Text */.L.Text,
          name: field.label,
          value: values[field.id],
          onChange: function onChange(e) {
            return handleChange(e, field);
          }
        });

      case InputType.TextArea:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
          type: TextInput/* TextInputType.TextArea */.L.TextArea,
          rows: 6,
          name: field.label,
          value: values[field.id],
          onChange: function onChange(e) {
            return handleChange(e, field);
          }
        });

      case InputType.SelectBox:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* default */.Z, {
          name: field.label,
          value: values[field.id] || '',
          onChange: function onChange(e) {
            return handleChange(e, field);
          },
          selected: values[field.id] !== '',
          children: field.valueOptions.map(function (o, i) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
              value: o,
              children: o
            }, i);
          })
        });

      case InputType.RadioButton:
        return field.valueOptions.map(function (o, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(CheckInput/* default */.Z, {
            type: CheckInput/* InputType.Radio */.n.Radio,
            value: o,
            onChange: function onChange(e) {
              return handleChange(e, field);
            },
            checked: (values[field.id] || '') === o,
            children: o
          }, i);
        });

      default:
        return /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
          type: TextInput/* TextInputType.Text */.L.Text,
          name: field.label,
          value: values[field.id],
          onChange: function onChange(e) {
            return handleChange(e, field);
          }
        });
    }
  }, [values, handleChange]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: customerFields.map(function (f) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabeledContainer/* default */.Z, {
          label: toLabel(f, intl),
          requiredLabel: f.required,
          errorStyle: f.errors && f.errors.length !== 0,
          paddingTop: true,
          description: f.description,
          children: renderInput(f)
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_ErrorMessage, {
          errors: f.errors
        })]
      }, "".concat(f.id, "-").concat(f.label));
    })
  });
};

/* harmony default export */ var CustomerField = (CustomerFields);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/Customer/index.tsx















var FieldNames;

(function (FieldNames) {
  FieldNames["CustomerFields"] = "customerFields";
})(FieldNames || (FieldNames = {}));

var UserInfo = function UserInfo(props) {
  var dispatch = (0,src_redux/* useAppDispatch */.TL)();
  var settings = props.settings,
      postable = props.postable;
  var intl = (0,useIntl/* default */.Z)();

  var useSelector = function useSelector() {
    return (0,redux/* useShallowEqualSelector */.M)(function (state) {
      return {
        inputs: getInputs(state.merchantsProductsPurchasesInputs)
      };
    });
  };

  var _useSelector = useSelector(),
      inputs = _useSelector.inputs;

  (0,react.useEffect)(function () {
    (0,useScrollToTop/* scrollToTop */.k)();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var _useState = (0,react.useState)({
    customerFields: !!inputs && inputs.userInfo ? inputs.userInfo : createInitialState(settings.customerFields)
  }),
      fieldValues = _useState[0],
      setFieldValues = _useState[1];

  var submittable = (0,react.useMemo)(function () {
    return CustomerField_submittable(settings.customerFields, getValueByNestedString(fieldValues, FieldNames.CustomerFields));
  }, [fieldValues, settings.customerFields]);
  var handleChange = (0,react.useCallback)(function (name, value) {
    var changedState = changeObjectByNestedString(fieldValues, name, value);
    setFieldValues(changedState);
    dispatch(clearCustomerError(name));
  }, [dispatch, fieldValues]);
  var handleSubmit = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var schemeType, onSubmit;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            schemeType = props.schemeType, onSubmit = props.onSubmit;
            _context.prev = 1;
            _context.next = 4;
            return dispatch(inputPurchasingUserInfo(schemeType, inputs.productId, fieldValues));

          case 4:
            onSubmit();
            _context.next = 9;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7]]);
  })), [dispatch, props, inputs, fieldValues]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [settings.customerFields && /*#__PURE__*/(0,jsx_runtime.jsx)(CustomerField, {
      customerFields: settings.customerFields,
      onChange: handleChange,
      namePrefix: FieldNames.CustomerFields,
      values: getValueByNestedString(fieldValues, FieldNames.CustomerFields) || {}
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "px-[18px] py-5",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RSButton/* RSButton */.F, {
        variant: "basic",
        isBlock: true,
        isLoading: !postable,
        disabled: !submittable || !postable,
        value: intl.formatMessage({
          id: 'purchases.userInfo.submitButton'
        }),
        onClick: handleSubmit,
        children: intl.formatMessage({
          id: 'purchases.userInfo.submitButton'
        })
      })
    })]
  });
};

/* harmony default export */ var Customer = (UserInfo);
// EXTERNAL MODULE: ./src/atoms/SubmitButton/index.tsx
var SubmitButton = __webpack_require__(31630);
// EXTERNAL MODULE: ./src/molecules/merchant/products/purchases/PurchaseErrorMessage/PurchaseErrorMessage.module.scss
var PurchaseErrorMessage_module = __webpack_require__(32530);
var PurchaseErrorMessage_module_default = /*#__PURE__*/__webpack_require__.n(PurchaseErrorMessage_module);
;// CONCATENATED MODULE: ./src/molecules/merchant/products/purchases/PurchaseErrorMessage/index.tsx







var PurchaseErrorMessage = function PurchaseErrorMessage(_ref) {
  var className = _ref.className,
      errorType = _ref.errorType,
      labelType = _ref.labelType;
  var intl = (0,useIntl/* default */.Z)();
  var classes = classnames_default()((PurchaseErrorMessage_module_default()).PurchaseErrorMessage, className);
  var errorText = {};

  if (errorType === 'unexpected') {
    errorText = {
      description: "text.".concat(errorType, ".").concat(labelType),
      title: 'title'
    };
  } else {
    errorText = {
      description: "text.".concat(errorType),
      title: 'title'
    };
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (PurchaseErrorMessage_module_default()).PurchaseErrorMessage__Title,
      children: intl.formatMessage({
        id: "purchases.purchaseErrorMessage.".concat(errorText.title)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (PurchaseErrorMessage_module_default()).PurchaseErrorMessage__Paragraph,
      children: intl.formatMessage({
        id: "purchases.purchaseErrorMessage.".concat(errorText.description)
      })
    })]
  });
};

/* harmony default export */ var purchases_PurchaseErrorMessage = (PurchaseErrorMessage);
// EXTERNAL MODULE: ./src/molecules/merchant/products/purchases/CompletionFailed/CompletionFailed.module.scss
var CompletionFailed_module = __webpack_require__(68041);
var CompletionFailed_module_default = /*#__PURE__*/__webpack_require__.n(CompletionFailed_module);
;// CONCATENATED MODULE: ./src/molecules/merchant/products/purchases/CompletionFailed/index.tsx











var CompletionFailed = function CompletionFailed(props) {
  (0,useScrollToTop/* useScrollToTop */.Z)();
  var schemeType = props.schemeType,
      settings = props.settings,
      backTo = props.backTo;
  var intl = (0,useIntl/* default */.Z)();
  var labelType = schemeType === purchases/* SchemeType.Subscription */.Yr.Subscription ? 'subscription' : 'ticketBook';
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (CompletionFailed_module_default()).CompletionFailed,
    children: [settings.entireErrors && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: settings.entireErrors.map(function (errorType) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_PurchaseErrorMessage, {
          labelType: labelType,
          errorType: errorType,
          className: (CompletionFailed_module_default()).CompletionFailed__ErrorMessage
        }, errorType);
      })
    }), backTo && /*#__PURE__*/(0,jsx_runtime.jsx)(SubmitButton/* SubmitButton */.M, {
      onClick: backTo.modifyPage,
      value: intl.formatMessage({
        id: backTo.label
      }),
      children: intl.formatMessage({
        id: backTo.label
      })
    })]
  });
};

/* harmony default export */ var purchases_CompletionFailed = (CompletionFailed);
// EXTERNAL MODULE: ./node_modules/lodash-es/range.js + 3 modules
var range = __webpack_require__(5941);
// EXTERNAL MODULE: ./node_modules/lodash-es/camelCase.js + 10 modules
var camelCase = __webpack_require__(20320);
// EXTERNAL MODULE: ./src/molecules/common/DeletableTextInput/index.tsx
var DeletableTextInput = __webpack_require__(34480);
// EXTERNAL MODULE: ./src/molecules/common/SecurityCodeMessage/index.tsx
var SecurityCodeMessage = __webpack_require__(5963);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/Payment/components/PaymentCreditCard/index.tsx


function PaymentCreditCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PaymentCreditCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PaymentCreditCard_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PaymentCreditCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var submittable = function submittable(creditCard) {
  return !!creditCard.cardNumber && !!creditCard.securityCode && !!creditCard.month && !!creditCard.year;
};

var createYearOptions = function createYearOptions() {
  var thisYear = new Date().getFullYear();
  return (0,range/* default */.Z)(thisYear, thisYear + 15).map(function (year) {
    return {
      label: year.toString(),
      value: year
    };
  });
};

var createMonthOptions = function createMonthOptions() {
  return (0,range/* default */.Z)(1, 12 + 1).map(function (month) {
    return {
      label: month.toString(),
      value: month
    };
  });
};

var PaymentCreditCard = function PaymentCreditCard(_ref) {
  var error = _ref.error,
      creditCard = _ref.creditCard,
      onChange = _ref.onChange;
  var intl = (0,useIntl/* default */.Z)();
  var handleChange = (0,react.useCallback)(function (e) {
    var _e$currentTarget = e.currentTarget,
        name = _e$currentTarget.name,
        value = _e$currentTarget.value;
    var changedState = changeObjectByNestedString({
      creditCard: PaymentCreditCard_objectSpread({}, creditCard)
    }, name, value);
    onChange(changedState.creditCard);
  }, [creditCard, onChange]);
  var yearOptions = createYearOptions();
  var monthOptions = createMonthOptions();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [error && error.field === 'card' && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: intl.formatMessage({
        id: "common.stripe.errorMessage.".concat((0,camelCase/* default */.Z)(error.type))
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabeledContainer/* default */.Z, {
      label: intl.formatMessage({
        id: 'purchases.paymentCreditCard.creditCardNumber'
      }),
      paddingTop: true,
      requiredLabel: true,
      errorStyle: error && error.field === 'number',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DeletableTextInput/* default */.Z, {
        type: TextInput/* TextInputType.Text */.L.Text,
        value: creditCard.cardNumber || '',
        name: "creditCard.cardNumber",
        onChange: handleChange
      })
    }), error && error.field === 'number' && /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
      children: intl.formatMessage({
        id: "common.stripe.errorMessage.".concat((0,camelCase/* default */.Z)(error.type))
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabeledContainer/* default */.Z, {
      label: intl.formatMessage({
        id: 'purchases.paymentCreditCard.expirationYear'
      }),
      requiredLabel: true,
      errorStyle: error && error.field === 'year',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* default */.Z, {
        name: "creditCard.year",
        value: creditCard.year || '',
        onChange: handleChange,
        selected: creditCard.year !== undefined,
        children: yearOptions.map(function (o, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "purchases.paymentCreditCard.year",
            values: {
              year: o.label
            },
            children: function children(year) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                value: o.value,
                children: year
              });
            }
          }, i);
        })
      })
    }), error && error.field === 'year' && /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
      children: intl.formatMessage({
        id: "common.stripe.errorMessage.".concat((0,camelCase/* default */.Z)(error.type))
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabeledContainer/* default */.Z, {
      label: intl.formatMessage({
        id: 'purchases.paymentCreditCard.expirationMonth'
      }),
      requiredLabel: true,
      errorStyle: error && error.field === 'month',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* default */.Z, {
        name: "creditCard.month",
        value: creditCard.month || '',
        onChange: handleChange,
        selected: creditCard.month !== undefined,
        children: monthOptions.map(function (o, i) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
            id: "purchases.paymentCreditCard.month",
            values: {
              month: o.label
            },
            children: function children(month) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
                value: o.value,
                children: month
              });
            }
          }, i);
        })
      })
    }), error && error.field === 'month' && /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
      children: intl.formatMessage({
        id: "common.stripe.errorMessage.".concat((0,camelCase/* default */.Z)(error.type))
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabeledContainer/* default */.Z, {
      label: intl.formatMessage({
        id: 'purchases.paymentCreditCard.securityCode'
      }),
      requiredLabel: true,
      errorStyle: error && error.field === 'cvc',
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(DeletableTextInput/* default */.Z, {
        type: TextInput/* TextInputType.Password */.L.Password,
        maxLength: 4,
        value: creditCard.securityCode || '',
        name: "creditCard.securityCode",
        onChange: handleChange
      })
    }), error && error.field === 'cvc' && /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
      children: intl.formatMessage({
        id: "common.stripe.errorMessage.".concat((0,camelCase/* default */.Z)(error.type))
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SecurityCodeMessage/* default */.Z, {})]
  });
};

/* harmony default export */ var components_PaymentCreditCard = (PaymentCreditCard);
// EXTERNAL MODULE: ./src/organisms/merchants/products/purchases/PaymentMethodsSelector/components/PurchasePaymentCard/PurchasePaymentCard.module.scss
var PurchasePaymentCard_module = __webpack_require__(41703);
var PurchasePaymentCard_module_default = /*#__PURE__*/__webpack_require__.n(PurchasePaymentCard_module);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/PaymentMethodsSelector/components/PurchasePaymentCard/index.tsx


var PurchasePaymentCard_excluded = ["tailDigits", "onChange"];

function PurchasePaymentCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PurchasePaymentCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PurchasePaymentCard_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PurchasePaymentCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var PurchasePaymentCard = function PurchasePaymentCard(_ref) {
  var tailDigits = _ref.tailDigits,
      onChange = _ref.onChange,
      attr = (0,objectWithoutProperties/* default */.Z)(_ref, PurchasePaymentCard_excluded);

  var classes = classnames_default()((PurchasePaymentCard_module_default()).PurchasePaymentCard);
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classes,
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CheckInput/* default */.Z, PurchasePaymentCard_objectSpread(PurchasePaymentCard_objectSpread({}, attr), {}, {
      type: CheckInput/* InputType.Radio */.n.Radio,
      name: "payment-creditcard",
      onChange: onChange,
      children: [intl.formatMessage({
        id: 'purchases.purchasePaymentCard.history'
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        className: (PurchasePaymentCard_module_default()).PurchasePaymentCard__Card,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          className: (PurchasePaymentCard_module_default()).PurchasePaymentCard__Mask,
          children: "\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 "
        }), tailDigits]
      })]
    }))
  });
};

/* harmony default export */ var components_PurchasePaymentCard = (PurchasePaymentCard);
// EXTERNAL MODULE: ./src/molecules/common/CardBrandList/index.tsx + 6 modules
var CardBrandList = __webpack_require__(28146);
// EXTERNAL MODULE: ./src/organisms/merchants/products/purchases/PaymentMethodsSelector/PaymentMethodsSelector.module.scss
var PaymentMethodsSelector_module = __webpack_require__(48772);
var PaymentMethodsSelector_module_default = /*#__PURE__*/__webpack_require__.n(PaymentMethodsSelector_module);
;// CONCATENATED MODULE: ./src/redux/selectors/merchants/products/purchases/index.ts
var getPurchases = function getPurchases(state) {
  return state;
};
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/PaymentMethodsSelector/index.tsx













var PaymentMethodsSelector = function PaymentMethodsSelector(_ref) {
  var me = _ref.me,
      selection = _ref.selection,
      onSelect = _ref.onSelect;
  var intl = (0,useIntl/* default */.Z)();
  var handleChange = (0,react.useCallback)(function (e) {
    var value = e.currentTarget.value;
    onSelect(value);
  }, [onSelect]);
  var merchantProductsPurchaseState = (0,es/* useSelector */.v9)(function (state) {
    return getPurchases(state.merchantsProductsPurchases);
  }, es/* shallowEqual */.wU);
  var jcbEnabled = merchantProductsPurchaseState.jcbEnabled;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(LabeledContainer/* default */.Z, {
    label: intl.formatMessage({
      id: 'purchases.paymentMethodsSelector.pleaseSelect'
    }),
    paddingTop: true,
    children: [me.creditCard && /*#__PURE__*/(0,jsx_runtime.jsx)(components_PurchasePaymentCard, {
      tailDigits: me.creditCard.tailDigits,
      value: purchases/* PaymentSelection.UsedCreditCard */.fS.UsedCreditCard,
      checked: selection === purchases/* PaymentSelection.UsedCreditCard */.fS.UsedCreditCard,
      onChange: handleChange
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(CheckInput/* default */.Z, {
      type: CheckInput/* InputType.Radio */.n.Radio,
      value: purchases/* PaymentSelection.AnotherCreditCard */.fS.AnotherCreditCard,
      checked: selection === purchases/* PaymentSelection.AnotherCreditCard */.fS.AnotherCreditCard,
      onChange: handleChange,
      name: "payment-creditcard",
      children: [intl.formatMessage({
        id: 'purchases.paymentMethodsSelector.addNewCreditCard'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (PaymentMethodsSelector_module_default()).card_brand_list_wrapper,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardBrandList/* CardBrandList */.n, {
          isJCBEnabled: jcbEnabled
        })
      })]
    })]
  });
};

/* harmony default export */ var purchases_PaymentMethodsSelector = (PaymentMethodsSelector);
// EXTERNAL MODULE: ./src/redux/selectors/users/index.ts
var selectors_users = __webpack_require__(5234);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/Payment/index.tsx


















var createSubmittable = function createSubmittable(me, creditCard, selection) {
  if (!me.creditCard) {
    return !!creditCard && submittable(creditCard);
  }

  if (!selection) {
    return false;
  }

  if (selection === purchases/* PaymentSelection.UsedCreditCard */.fS.UsedCreditCard) {
    return true;
  }

  return !!creditCard && submittable(creditCard);
};

var Payment = function Payment(_ref) {
  var schemeType = _ref.schemeType,
      settings = _ref.settings,
      postable = _ref.postable,
      onSubmit = _ref.onSubmit,
      merchantPublicId = _ref.merchantPublicId;
  var intl = (0,useIntl/* default */.Z)();
  (0,useScrollToTop/* useScrollToTop */.Z)();
  var dispatch = (0,src_redux/* useAppDispatch */.TL)();

  var _useState = (0,react.useState)(false),
      submittable = _useState[0],
      setSubmittable = _useState[1];

  var _useState2 = (0,react.useState)(purchases/* PaymentSelection.UsedCreditCard */.fS.UsedCreditCard),
      selection = _useState2[0],
      setSelection = _useState2[1];

  var _useState3 = (0,react.useState)(undefined),
      creditCard = _useState3[0],
      setCreditCard = _useState3[1];

  var me = (0,es/* useSelector */.v9)(function (state) {
    return (0,selectors_users/* getMe */.j)(state.users);
  }, es/* shallowEqual */.wU);
  var inputs = (0,es/* useSelector */.v9)(function (state) {
    return getInputs(state.merchantsProductsPurchasesInputs);
  }, es/* shallowEqual */.wU);
  (0,react.useEffect)(function () {
    var init = function init() {
      setCreditCard(inputs.payment ? inputs.payment.creditCard : undefined);
      setSelection(me.creditCard ? purchases/* PaymentSelection.UsedCreditCard */.fS.UsedCreditCard : purchases/* PaymentSelection.AnotherCreditCard */.fS.AnotherCreditCard);
      setSubmittable(createSubmittable(me, creditCard, selection));
    };

    init();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleSelect = (0,react.useCallback)(function (selection) {
    setSelection(selection);
    setSubmittable(createSubmittable(me, creditCard, selection));
  }, [me, creditCard]);
  var handleChange = (0,react.useCallback)(function (creditCard) {
    setCreditCard(creditCard);
    setSubmittable(createSubmittable(me, creditCard, selection));
  }, [me, selection]);
  var handleSubmit = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return dispatch(inputPurchasingPayment(schemeType, inputs.productId, {
              creditCard: creditCard,
              selection: selection
            }, merchantPublicId));

          case 3:
            onSubmit();
            _context.next = 8;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  })), [dispatch, schemeType, inputs.productId, onSubmit, creditCard, selection, merchantPublicId]);
  var showInputCreditCard = (0,react.useMemo)(function () {
    if (!me.creditCard) return true;
    if (!selection) return false;
    return selection === purchases/* PaymentSelection.AnotherCreditCard */.fS.AnotherCreditCard;
  }, [me, selection]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(purchases_PaymentMethodsSelector, {
      me: me,
      selection: selection,
      onSelect: handleSelect
    }), showInputCreditCard && /*#__PURE__*/(0,jsx_runtime.jsx)(components_PaymentCreditCard, {
      error: settings.errors ? settings.errors.creditCard : undefined,
      creditCard: creditCard || {},
      onChange: handleChange
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "px-[18px] py-5",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(RSButton/* RSButton */.F, {
        variant: "basic",
        isBlock: true,
        isLoading: !postable,
        disabled: !submittable || !postable,
        value: intl.formatMessage({
          id: 'purchases.payment.submitButton'
        }),
        onClick: function onClick() {
          return handleSubmit();
        },
        children: intl.formatMessage({
          id: 'purchases.payment.submitButton'
        })
      })
    })]
  });
};

/* harmony default export */ var purchases_Payment = (Payment);
// EXTERNAL MODULE: ./src/molecules/merchant/products/purchases/Subscribed/index.module.scss
var index_module = __webpack_require__(34544);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/molecules/merchant/products/purchases/Subscribed/index.tsx








var Subscribed = function Subscribed(props) {
  var bookingPages = props.settings.bookingPages,
      publicId = props.publicId;
  (0,useScrollToTop/* useScrollToTop */.Z)();
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (index_module_default()).Subscribed,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (index_module_default()).Subscribed__MessageSection,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (index_module_default()).Subscribed__MessageTitle,
        children: intl.formatMessage({
          id: "purchases.subscribed.title"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (index_module_default()).Subscribed__MessageParagraph,
        children: intl.formatMessage({
          id: "purchases.subscribed.message1"
        })
      })]
    }), bookingPages.length !== 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_AvailableBookingPageList, {
      publicId: publicId,
      bookingPages: bookingPages
    })]
  });
};

/* harmony default export */ var purchases_Subscribed = (Subscribed);
// EXTERNAL MODULE: ./src/hooks/api/auth/index.ts + 1 modules
var auth = __webpack_require__(59339);
// EXTERNAL MODULE: ./src/organisms/merchants/products/purchases/Auth/components/PurchaseLoginRequireAlert/PurchaseLoginRequireAlert.module.scss
var PurchaseLoginRequireAlert_module = __webpack_require__(84792);
var PurchaseLoginRequireAlert_module_default = /*#__PURE__*/__webpack_require__.n(PurchaseLoginRequireAlert_module);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/Auth/components/PurchaseLoginRequireAlert/index.tsx







var PurchaseLoginRequireAlert = function PurchaseLoginRequireAlert(_ref) {
  var labelType = _ref.labelType,
      onClick = _ref.onClick;
  var classes = classnames_default()((PurchaseLoginRequireAlert_module_default()).PurchaseLoginRequireAlert);
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: classes,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (PurchaseLoginRequireAlert_module_default()).PurchaseLoginRequireAlert__Paragraph,
      children: intl.formatMessage({
        id: "purchases.purchaseLoginRequireAlert.message1.".concat(labelType)
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (PurchaseLoginRequireAlert_module_default()).PurchaseLoginRequireAlert__Paragraph,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: 'purchases.purchaseLoginRequireAlert.message2',
        values: {
          createUser: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            onClick: onClick,
            className: (PurchaseLoginRequireAlert_module_default()).PurchaseLoginRequireAlert__Link,
            children: intl.formatMessage({
              id: 'purchases.purchaseLoginRequireAlert.here'
            })
          })
        }
      })
    })]
  });
};

/* harmony default export */ var components_PurchaseLoginRequireAlert = (PurchaseLoginRequireAlert);
// EXTERNAL MODULE: ./src/organisms/merchants/products/purchases/Auth/components/PurchaseCreateUserConfirmAlert/PurchaseCreateUserConfirmAlert.module.scss
var PurchaseCreateUserConfirmAlert_module = __webpack_require__(752);
var PurchaseCreateUserConfirmAlert_module_default = /*#__PURE__*/__webpack_require__.n(PurchaseCreateUserConfirmAlert_module);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/Auth/components/PurchaseCreateUserConfirmAlert/index.tsx







var PurchaseCreateUserConfirmAlert = function PurchaseCreateUserConfirmAlert() {
  var classes = classnames_default()((PurchaseCreateUserConfirmAlert_module_default()).PurchaseCreateUserConfirmAlert);
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classes,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: (PurchaseCreateUserConfirmAlert_module_default()).PurchaseCreateUserConfirmAlert__Paragraph,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(message/* default */.Z, {
        id: "purchases.purchaseCreateUserConfirmAlert.message",
        values: {
          terms: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: '/user_terms',
            prefetch: false,
            className: (PurchaseCreateUserConfirmAlert_module_default()).PurchaseCreateUserConfirmAlert__Link,
            target: "_blank",
            rel: "noopener noreferrer",
            children: intl.formatMessage({
              id: 'purchases.purchaseCreateUserConfirmAlert.termOfUse'
            })
          })
        }
      })
    })
  });
};

/* harmony default export */ var components_PurchaseCreateUserConfirmAlert = (PurchaseCreateUserConfirmAlert);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/Auth/components/CreateUserErrorMessage/index.tsx


var CreateUserErrorMessage_ERROR_COMPONENTS;






var CreateUserErrorMessage_ErrorType;

(function (ErrorType) {
  ErrorType["Blank"] = "blank";
  ErrorType["Failed"] = "failed";
  ErrorType["Taken"] = "taken";
  ErrorType["Invalid"] = "invalid";
})(CreateUserErrorMessage_ErrorType || (CreateUserErrorMessage_ErrorType = {}));

var CreateUserErrorMessage_BlankMessage = function BlankMessage() {
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
    children: intl.formatMessage({
      id: "purchases.errors.createUser.blank",
      defaultMessage: intl.formatMessage({
        id: 'purchases.errors.blank'
      })
    })
  });
};

var TakenMessage = function TakenMessage() {
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
    children: intl.formatMessage({
      id: "purchases.errors.createUser.taken",
      defaultMessage: intl.formatMessage({
        id: 'purchases.errors.taken'
      })
    })
  });
};

var CreateUserErrorMessage_InvalidMessage = function InvalidMessage() {
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
    children: intl.formatMessage({
      id: "purchases.errors.createUser.invalid",
      defaultMessage: intl.formatMessage({
        id: 'purchases.errors.invalid'
      })
    })
  });
};

var components_CreateUserErrorMessage_ERROR_COMPONENTS = (CreateUserErrorMessage_ERROR_COMPONENTS = {}, (0,defineProperty/* default */.Z)(CreateUserErrorMessage_ERROR_COMPONENTS, CreateUserErrorMessage_ErrorType.Blank, CreateUserErrorMessage_BlankMessage), (0,defineProperty/* default */.Z)(CreateUserErrorMessage_ERROR_COMPONENTS, CreateUserErrorMessage_ErrorType.Taken, TakenMessage), (0,defineProperty/* default */.Z)(CreateUserErrorMessage_ERROR_COMPONENTS, CreateUserErrorMessage_ErrorType.Invalid, CreateUserErrorMessage_InvalidMessage), (0,defineProperty/* default */.Z)(CreateUserErrorMessage_ERROR_COMPONENTS, CreateUserErrorMessage_ErrorType.Failed, undefined), CreateUserErrorMessage_ERROR_COMPONENTS);

var CreateUserErrorMessage_ErrorMessage = function ErrorMessage(_ref) {
  var errors = _ref.errors;
  if (!errors) return null;
  if (errors.length === 0) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: errors.map(function (error, index) {
      var Component = components_CreateUserErrorMessage_ERROR_COMPONENTS[error];
      if (!Component) return null;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {}, index);
    })
  });
};

/* harmony default export */ var CreateUserErrorMessage = (CreateUserErrorMessage_ErrorMessage);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/Auth/components/CreateUser/index.tsx












var InputCreateUser = function InputCreateUser(props) {
  var intl = (0,useIntl/* default */.Z)();

  var _useState = (0,react.useState)(''),
      lastName = _useState[0],
      setLastName = _useState[1];

  var _useState2 = (0,react.useState)(''),
      firstName = _useState2[0],
      setFirstName = _useState2[1];

  var _useState3 = (0,react.useState)(''),
      email = _useState3[0],
      setEmail = _useState3[1];

  var _useState4 = (0,react.useState)(''),
      password = _useState4[0],
      setPassword = _useState4[1];

  var submittable = (0,react.useMemo)(function () {
    return !!lastName && !!firstName && !!email && !!password;
  }, [lastName, firstName, email, password]);

  var handleChange = function handleChange(e) {
    var _e$currentTarget = e.currentTarget,
        name = _e$currentTarget.name,
        value = _e$currentTarget.value;

    switch (name) {
      case 'lastName':
        setLastName(value);
        break;

      case 'firstName':
        setFirstName(value);
        break;

      case 'email':
        setEmail(value);
        break;

      case 'password':
        setPassword(value);
        break;

      default:
        break;
    }
  };

  var handleSubmit = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            props.onSubmit({
              lastName: lastName,
              firstName: firstName,
              email: email,
              password: password
            });

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [props, lastName, firstName, email, password]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabeledContainer/* default */.Z, {
      label: intl.formatMessage({
        id: 'purchases.inputCreateUser.lastName'
      }),
      paddingTop: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
        type: TextInput/* TextInputType.Text */.L.Text,
        name: 'lastName',
        value: lastName,
        onChange: handleChange
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabeledContainer/* default */.Z, {
      label: intl.formatMessage({
        id: 'purchases.inputCreateUser.firstName'
      }),
      paddingTop: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
        type: TextInput/* TextInputType.Text */.L.Text,
        name: 'firstName',
        value: firstName,
        onChange: handleChange
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabeledContainer/* default */.Z, {
      label: intl.formatMessage({
        id: 'purchases.inputCreateUser.email'
      }),
      paddingTop: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
        type: TextInput/* TextInputType.Email */.L.Email,
        name: 'email',
        value: email,
        onChange: handleChange
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabeledContainer/* default */.Z, {
      label: intl.formatMessage({
        id: 'purchases.inputCreateUser.password'
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
        type: TextInput/* TextInputType.Password */.L.Password,
        name: 'password',
        value: password,
        onChange: handleChange,
        placeholder: intl.formatMessage({
          id: 'purchases.inputCreateUser.passwordPlaceholder'
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CreateUserErrorMessage, {
      errors: props.errors
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_PurchaseCreateUserConfirmAlert, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(SubmitButton/* SubmitButton */.M, {
      type: "button",
      onClick: handleSubmit,
      value: intl.formatMessage({
        id: 'purchases.inputCreateUser.submitButton'
      }),
      disabled: !submittable || !props.postable,
      postable: props.postable,
      children: intl.formatMessage({
        id: 'purchases.inputCreateUser.submitButton'
      })
    })]
  });
};

/* harmony default export */ var CreateUser = (InputCreateUser);
// EXTERNAL MODULE: ./src/utils/facebook-api-id.ts
var facebook_api_id = __webpack_require__(9405);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/Auth/components/LoginErrorMessage/index.tsx


var LoginErrorMessage_ERROR_COMPONENTS;






var LoginErrorMessage_ErrorType;

(function (ErrorType) {
  ErrorType["Blank"] = "blank";
  ErrorType["Failed"] = "failed";
  ErrorType["Taken"] = "taken";
  ErrorType["Invalid"] = "invalid";
})(LoginErrorMessage_ErrorType || (LoginErrorMessage_ErrorType = {}));

var LoginErrorMessage_BlankMessage = function BlankMessage() {
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
    children: intl.formatMessage({
      id: "purchases.errors.login.blank",
      defaultMessage: intl.formatMessage({
        id: 'purchases.errors.blank'
      })
    })
  });
};

var FailedMessage = function FailedMessage() {
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FormErrorMessage/* default */.Z, {
    children: intl.formatMessage({
      id: "purchases.errors.login.failed",
      defaultMessage: intl.formatMessage({
        id: 'purchases.errors.failed'
      })
    })
  });
};

var components_LoginErrorMessage_ERROR_COMPONENTS = (LoginErrorMessage_ERROR_COMPONENTS = {}, (0,defineProperty/* default */.Z)(LoginErrorMessage_ERROR_COMPONENTS, LoginErrorMessage_ErrorType.Blank, LoginErrorMessage_BlankMessage), (0,defineProperty/* default */.Z)(LoginErrorMessage_ERROR_COMPONENTS, LoginErrorMessage_ErrorType.Taken, undefined), (0,defineProperty/* default */.Z)(LoginErrorMessage_ERROR_COMPONENTS, LoginErrorMessage_ErrorType.Invalid, undefined), (0,defineProperty/* default */.Z)(LoginErrorMessage_ERROR_COMPONENTS, LoginErrorMessage_ErrorType.Failed, FailedMessage), LoginErrorMessage_ERROR_COMPONENTS);

var LoginErrorMessage_ErrorMessage = function ErrorMessage(props) {
  var errors = props.errors;

  if (!errors) {
    return null;
  }

  if (errors.length === 0) {
    return null;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: errors.map(function (error, index) {
      var Component = components_LoginErrorMessage_ERROR_COMPONENTS[error];
      if (!Component) return null;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {}, index);
    })
  });
};

/* harmony default export */ var LoginErrorMessage = (LoginErrorMessage_ErrorMessage);
// EXTERNAL MODULE: ./src/molecules/common/PasswordForgot/index.tsx
var PasswordForgot = __webpack_require__(81079);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/Auth/components/Login/index.tsx













var InputLogin = function InputLogin(props) {
  var intl = (0,useIntl/* default */.Z)();

  var _useState = (0,react.useState)(''),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = (0,react.useState)(''),
      password = _useState2[0],
      setPassword = _useState2[1];

  var submittable = (0,react.useMemo)(function () {
    return !!email && !!password;
  }, [email, password]);
  (0,react.useEffect)(function () {
    loadFbLoginApi();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var loadFbLoginApi = function loadFbLoginApi() {
    window.fbAsyncInit = function () {
      FB.init({
        appId: facebook_api_id/* default */.Z,
        cookie: true,
        xfbml: true,
        version: 'v4.0'
      });
      FB.AppEvents.logPageView();
    };

    (function (d) {
      var fjs = d.getElementsByTagName('script')[0];

      if (d.getElementById('facebook-jssdk')) {
        return;
      }

      var js = d.createElement('script');
      js.id = 'facebook-jssdk';
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    })(document);
  };

  var handleChange = function handleChange(e) {
    var _e$currentTarget = e.currentTarget,
        name = _e$currentTarget.name,
        value = _e$currentTarget.value;
    if (name === 'email') setEmail(value);
    if (name === 'password') setPassword(value);
  };

  var handleSubmit = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            props.onLogin({
              email: email,
              password: password
            });

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [email, password, props]);

  var handleFacebookSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              FB.login(function (resLogin) {
                if (resLogin.authResponse) {
                  FB.api('/me?fields=email,first_name,last_name', function (resMe) {
                    var query = {
                      email: resMe.email,
                      id: resMe.id,
                      accessToken: resLogin.authResponse.accessToken,
                      firstName: resMe.first_name,
                      lastName: resMe.last_name,
                      expireAt: resLogin.authResponse.expiresIn
                    };
                    props.onLoginWithFb(query);
                  });
                }
              }, {
                scope: 'email'
              });

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleFacebookSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();

  var doYouForgetPassword = intl.formatMessage({
    id: 'auth.login.links.forgotPassword'
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LabeledContainer/* default */.Z, {
      label: intl.formatMessage({
        id: 'purchases.inputLogin.email'
      }),
      paddingTop: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
        type: TextInput/* TextInputType.Email */.L.Email,
        name: 'email',
        value: email,
        onChange: handleChange
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LabeledContainer/* default */.Z, {
      label: intl.formatMessage({
        id: 'purchases.inputLogin.password'
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* default */.Z, {
        type: TextInput/* TextInputType.Password */.L.Password,
        name: 'password',
        value: password,
        onChange: handleChange
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(LoginErrorMessage, {
      errors: props.errors
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PasswordForgot/* PasswordForgot */.$, {
      message: doYouForgetPassword
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubmitButton/* SubmitButton */.M, {
      type: "button",
      onClick: handleSubmit,
      value: intl.formatMessage({
        id: 'purchases.inputLogin.submitLogin'
      }),
      disabled: !submittable || !props.postable,
      postable: props.postable,
      children: intl.formatMessage({
        id: 'purchases.inputLogin.submitLogin'
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubmitButton/* SubmitButton */.M, {
      type: "button",
      onClick: handleFacebookSubmit,
      value: intl.formatMessage({
        id: 'purchases.inputLogin.submitFacebookLogin'
      }),
      disabled: !props.postable,
      postable: props.postable,
      variant: "Secondary",
      children: intl.formatMessage({
        id: 'purchases.inputLogin.submitFacebookLogin'
      })
    })]
  });
};

/* harmony default export */ var Login = (InputLogin);
// EXTERNAL MODULE: ./src/molecules/common/CreateUserAlert/index.tsx
var CreateUserAlert = __webpack_require__(62009);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/Auth/index.tsx

















var ViewType;

(function (ViewType) {
  ViewType["Login"] = "login";
  ViewType["CreateUser"] = "createUser";
})(ViewType || (ViewType = {}));

var InputRequireLogin = function InputRequireLogin(props) {
  var schemeType = props.schemeType,
      onSubmit = props.onSubmit,
      onSubmitSubscribed = props.onSubmitSubscribed,
      postable = props.postable,
      isEmailVerified = props.isEmailVerified,
      onJustCreateUser = props.onJustCreateUser;
  var dispatch = (0,src_redux/* useAppDispatch */.TL)();

  var _useAuth = (0,auth/* useAuth */.a)(),
      login = _useAuth.login,
      loginWithFb = _useAuth.loginWithFb,
      createUser = _useAuth.createUser;

  var _useState = (0,react.useState)(),
      errors = _useState[0],
      setErrors = _useState[1];

  var _useState2 = (0,react.useState)(ViewType.Login),
      viewType = _useState2[0],
      setViewType = _useState2[1];

  var inputs = (0,es/* useSelector */.v9)(function (state) {
    return getInputs(state.merchantsProductsPurchasesInputs);
  }, es/* shallowEqual */.wU);

  var handleSwitchView = function handleSwitchView(viewType) {
    setViewType(viewType);
  };

  var handleLogined = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var userSubscription;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return dispatch(setMeToPurchaseInfo(inputs.productId));

          case 2:
            if (!(schemeType === purchases/* SchemeType.Subscription */.Yr.Subscription)) {
              _context.next = 7;
              break;
            }

            _context.next = 5;
            return api/* fetchUsersSubscription */.l(inputs.productId);

          case 5:
            userSubscription = _context.sent;

            if (userSubscription && onSubmitSubscribed) {
              onSubmitSubscribed();
            } else {
              if (isEmailVerified) {
                onSubmit();
              }
            }

          case 7:
            if (schemeType === purchases/* SchemeType.TicketBook */.Yr.TicketBook && isEmailVerified) {
              onSubmit();
            }

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [dispatch, inputs.productId, onSubmitSubscribed, onSubmit, schemeType, isEmailVerified]);
  var handleLogin = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(_q) {
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              dispatch(setPostable(false));
              login(_q.email, _q.password).then( /*#__PURE__*/function () {
                var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref3) {
                  var errorType;
                  return regenerator_default().wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          errorType = _ref3.errorType;

                          if (!errorType) {
                            _context2.next = 3;
                            break;
                          }

                          return _context2.abrupt("return", setErrors([errorType]));

                        case 3:
                          _context2.next = 5;
                          return handleLogined();

                        case 5:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }())["catch"](function (_err) {
                return;
              })["finally"](function () {
                return setPostable(true);
              });

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [dispatch, handleLogined, login]);
  var handleLoginWithFb = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5(query) {
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              dispatch(setPostable(false));
              loginWithFb(query).then( /*#__PURE__*/function () {
                var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4(_ref6) {
                  var errorType;
                  return regenerator_default().wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          errorType = _ref6.errorType;

                          if (!errorType) {
                            _context4.next = 3;
                            break;
                          }

                          return _context4.abrupt("return", setErrors([errorType]));

                        case 3:
                          _context4.next = 5;
                          return handleLogined();

                        case 5:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function (_x4) {
                  return _ref7.apply(this, arguments);
                };
              }())["catch"](function (_err) {
                return;
              })["finally"](function () {
                return setPostable(true);
              });

            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }(), [dispatch, handleLogined, loginWithFb]);
  var handleCreateUser = (0,react.useCallback)( /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(query) {
      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              dispatch(setPostable(false));
              createUser(query).then( /*#__PURE__*/function () {
                var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6(_ref9) {
                  var errorType;
                  return regenerator_default().wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          errorType = _ref9.errorType;

                          if (!errorType) {
                            _context6.next = 3;
                            break;
                          }

                          return _context6.abrupt("return", setErrors([errorType]));

                        case 3:
                          onJustCreateUser === null || onJustCreateUser === void 0 ? void 0 : onJustCreateUser();
                          _context6.next = 6;
                          return handleLogined();

                        case 6:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));

                return function (_x6) {
                  return _ref10.apply(this, arguments);
                };
              }())["catch"](function (_err) {
                return;
              })["finally"](function () {
                return setPostable(true);
              });

            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x5) {
      return _ref8.apply(this, arguments);
    };
  }(), [createUser, dispatch, handleLogined, onJustCreateUser]);
  var labelType = schemeType === purchases/* SchemeType.Subscription */.Yr.Subscription ? 'subscription' : 'ticketBook';
  if (viewType === ViewType.Login) return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(components_PurchaseLoginRequireAlert, {
      labelType: labelType,
      onClick: function onClick() {
        return handleSwitchView(ViewType.CreateUser);
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Login, {
      postable: postable,
      onLogin: function onLogin(query) {
        return handleLogin(query);
      },
      onLoginWithFb: function onLoginWithFb(query) {
        return handleLoginWithFb(query);
      },
      errors: errors
    })]
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CreateUserAlert/* default */.Z, {
      onClick: function onClick() {
        return handleSwitchView(ViewType.Login);
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CreateUser, {
      postable: postable,
      onSubmit: function onSubmit(query) {
        return handleCreateUser(query);
      },
      errors: errors
    })]
  });
};

/* harmony default export */ var Auth = (InputRequireLogin);
// EXTERNAL MODULE: ./src/hooks/api/me/index.ts + 2 modules
var me = __webpack_require__(21966);
// EXTERNAL MODULE: ./src/hooks/api/sendVerification/index.ts
var sendVerification = __webpack_require__(78902);
// EXTERNAL MODULE: ./src/molecules/common/LoadingIconWithReloadButton/index.tsx + 1 modules
var LoadingIconWithReloadButton = __webpack_require__(18386);
// EXTERNAL MODULE: ./src/molecules/common/EmailVerification/index.tsx
var EmailVerification = __webpack_require__(52953);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/ProductPurchaseAuth/index.tsx











var ProductPurchaseAuth = function ProductPurchaseAuth(_ref) {
  var postable = _ref.postable,
      moveToNext = _ref.moveToNext,
      onSubmitSubscribed = _ref.onSubmitSubscribed,
      schemeType = _ref.schemeType,
      isEmailVerified = _ref.isEmailVerified,
      isLoggedIn = _ref.isLoggedIn;
  var intl = (0,useIntl/* default */.Z)();

  var _useState = (0,react.useState)(false),
      isJustCreateUser = _useState[0],
      setIsJustCreateUser = _useState[1];

  var _useUserMe = (0,me/* useUserMe */.J1)(),
      loginUser = _useUserMe.meResponseData;

  var _useResendVerificatio = (0,sendVerification/* useResendVerificationMail */.p)(),
      isValidating = _useResendVerificatio.isValidating,
      resendVerificationMail = _useResendVerificatio.resendVerificationMail;

  var onJustCreateUser = (0,react.useCallback)(function () {
    setIsJustCreateUser(true);
  }, []);
  var onRequestResendEmail = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var res, message, _message;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return resendVerificationMail();

          case 2:
            res = _context.sent;

            if (res.success) {
              message = intl.formatMessage({
                id: 'reservationFlowAuthPage.successResendEmail'
              });
              alert(message);
            } else {
              _message = intl.formatMessage({
                id: 'reservationFlowAuthPage.failedResendEmail'
              });
              alert(_message);
            }

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [resendVerificationMail, intl]);
  if (!isLoggedIn) return /*#__PURE__*/(0,jsx_runtime.jsx)(Auth, {
    postable: postable,
    onSubmit: moveToNext,
    schemeType: schemeType,
    onSubmitSubscribed: onSubmitSubscribed,
    isEmailVerified: isEmailVerified,
    onJustCreateUser: onJustCreateUser
  });

  if (loginUser && !isEmailVerified) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(EmailVerification/* default */.Z, {
      isJustCreateUser: isJustCreateUser,
      email: loginUser.email,
      isValidating: isValidating,
      handleSubmit: onRequestResendEmail,
      verificationContext: EmailVerification/* VerificationContext.PRODUCT */.N.PRODUCT
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(LoadingIconWithReloadButton/* LoadingIconWithReloadButton */.b, {});
};

/* harmony default export */ var purchases_ProductPurchaseAuth = (ProductPurchaseAuth);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/SchemeTypeSubscription/index.tsx
















var FULL_WORKFLOW_STEPS = [StepItems.Customer, StepItems.Payment, StepItems.Confirmation];
var SKIP_CUSTOMER_WORKFLOW_STEPS = [StepItems.Payment, StepItems.Confirmation];
var RETURN_TARGET_STEP = 97;
var RESTART_STEP = 98;
var SUBSCRIBED_STEP = 99;

var SchemeTypeSubscription = function SchemeTypeSubscription(_ref) {
  var isEmailVerified = _ref.isEmailVerified,
      isLoggedIn = _ref.isLoggedIn;
  var dispatch = (0,src_redux/* useAppDispatch */.TL)();

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return getPurchases(state.merchantsProductsPurchases);
  }, es/* shallowEqual */.wU),
      merchantProduct = _useSelector.merchantProduct,
      firstCharge = _useSelector.firstCharge,
      lastOrder = _useSelector.lastOrder,
      publicId = _useSelector.publicId,
      postable = _useSelector.postable,
      settings = _useSelector.settings,
      step = _useSelector.step;

  var renderAuthAt = (0,react.useCallback)(function (step) {
    if (settings === null) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_ProductPurchaseAuth, {
      schemeType: settings.schemeType,
      postable: postable,
      moveToNext: function moveToNext() {
        return dispatch(nextStep(step));
      },
      onSubmitSubscribed: function onSubmitSubscribed() {
        return dispatch(goTo(SUBSCRIBED_STEP));
      },
      isEmailVerified: isEmailVerified,
      isLoggedIn: isLoggedIn
    });
  }, [settings, postable, dispatch, isEmailVerified, isLoggedIn]);
  var renderCustomerAt = (0,react.useCallback)(function (step) {
    if (settings === null) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Customer, {
      schemeType: settings.schemeType,
      settings: settings.customer,
      postable: postable,
      onSubmit: function onSubmit() {
        return dispatch(nextStep(step));
      }
    });
  }, [settings, postable, dispatch]);
  var renderPaymentAt = (0,react.useCallback)(function (step) {
    if (!settings || !settings.payment) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_Payment, {
      schemeType: settings.schemeType,
      settings: settings.payment,
      merchantPublicId: publicId,
      postable: postable,
      onSubmit: function onSubmit() {
        return dispatch(nextStep(step));
      }
    });
  }, [settings, postable, dispatch, publicId]);
  var renderConfirmationAt = (0,react.useCallback)(function (step) {
    if (!settings || !merchantProduct || !firstCharge) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Confirmation, {
      schemeType: settings.schemeType,
      product: merchantProduct,
      firstCharge: firstCharge,
      settings: settings.confirmation,
      postable: postable,
      onSubmit: function onSubmit() {
        return dispatch(finalStep(step));
      },
      onRestart: function onRestart() {
        return dispatch(goTo(RESTART_STEP));
      },
      onReturnTargetStep: function onReturnTargetStep() {
        return dispatch(goTo(RETURN_TARGET_STEP));
      },
      publicId: publicId
    });
  }, [settings, merchantProduct, firstCharge, publicId, postable, dispatch]);
  var renderCompletion = (0,react.useCallback)(function () {
    if (!settings || !merchantProduct) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_Completion, {
      schemeType: settings.schemeType,
      settings: settings.completion,
      product: merchantProduct,
      firstCharge: firstCharge,
      lastOrder: lastOrder,
      publicId: publicId
    });
  }, [settings, merchantProduct, firstCharge, lastOrder, publicId]);
  var renderSubscribed = (0,react.useCallback)(function () {
    if (settings === null) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_Subscribed, {
      publicId: publicId,
      settings: settings.completion
    });
  }, [settings, publicId]);
  var renderFailedRestart = (0,react.useCallback)(function () {
    if (settings === null) return null;
    var backTo = {
      label: 'purchases.schemeTypeSubscription.restart',
      modifyPage: function modifyPage() {
        return location.reload();
      }
    };
    return /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_CompletionFailed, {
      schemeType: settings.schemeType,
      settings: settings.completion,
      backTo: backTo
    });
  }, [settings]);
  var renderFailedReturnTargetStep = (0,react.useCallback)(function (modifierStep) {
    if (settings === null) return null;
    var backTo = {
      label: 'purchases.schemeTypeSubscription.returnTargetStep',
      modifyPage: function modifyPage() {
        return dispatch(goTo(modifierStep));
      }
    };
    return /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_CompletionFailed, {
      schemeType: settings.schemeType,
      settings: settings.completion,
      backTo: backTo
    });
  }, [settings, dispatch]);
  var fullWorkFlowSetting = (0,react.useCallback)(function () {
    // prettier-ignore
    var setting = {
      0: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderAuthAt(0);
        }
      },
      1: {
        displayProgress: true,
        currentProgress: StepItems.Customer,
        renderFn: function renderFn() {
          return renderCustomerAt(1);
        }
      },
      2: {
        displayProgress: true,
        currentProgress: StepItems.Payment,
        renderFn: function renderFn() {
          return renderPaymentAt(2);
        }
      },
      3: {
        displayProgress: true,
        currentProgress: StepItems.Confirmation,
        renderFn: function renderFn() {
          return renderConfirmationAt(3);
        }
      },
      4: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderCompletion();
        }
      },
      97: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderFailedReturnTargetStep(1);
        }
      },
      98: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderFailedRestart();
        }
      },
      99: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderSubscribed();
        }
      }
    }[step];
    return [FULL_WORKFLOW_STEPS, setting];
  }, [step, renderAuthAt, renderCustomerAt, renderPaymentAt, renderConfirmationAt, renderCompletion, renderFailedRestart, renderFailedReturnTargetStep, renderSubscribed]);
  var skipCustomerFlowSetting = (0,react.useCallback)(function () {
    // prettier-ignore
    var setting = {
      0: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderAuthAt(0);
        }
      },
      1: {
        displayProgress: true,
        currentProgress: StepItems.Payment,
        renderFn: function renderFn() {
          return renderPaymentAt(1);
        }
      },
      2: {
        displayProgress: true,
        currentProgress: StepItems.Confirmation,
        renderFn: function renderFn() {
          return renderConfirmationAt(2);
        }
      },
      3: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderCompletion();
        }
      },
      97: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderFailedReturnTargetStep(1);
        }
      },
      98: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderFailedRestart();
        }
      },
      99: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderSubscribed();
        }
      }
    }[step];
    return [SKIP_CUSTOMER_WORKFLOW_STEPS, setting];
  }, [step, renderAuthAt, renderPaymentAt, renderConfirmationAt, renderCompletion, renderFailedReturnTargetStep, renderFailedRestart, renderSubscribed]);

  var _useMemo = (0,react.useMemo)(function () {
    return settings !== null && settings.customer.customerFields.length !== 0 ? fullWorkFlowSetting() : skipCustomerFlowSetting();
  }, [settings, fullWorkFlowSetting, skipCustomerFlowSetting]),
      allSteps = _useMemo[0],
      setting = _useMemo[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [setting && setting.currentProgress && setting.displayProgress && /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_PurchaseStep, {
      allSteps: allSteps,
      current: allSteps.indexOf(setting.currentProgress) + 1
    }), setting && setting.renderFn()]
  });
};

/* harmony default export */ var purchases_SchemeTypeSubscription = (SchemeTypeSubscription);
;// CONCATENATED MODULE: ./src/organisms/merchants/products/purchases/SchemeTypeTicketBook/index.tsx















var SchemeTypeTicketBook_FULL_WORKFLOW_STEPS = [StepItems.Customer, StepItems.Payment, StepItems.Confirmation];
var SchemeTypeTicketBook_SKIP_CUSTOMER_WORKFLOW_STEPS = [StepItems.Payment, StepItems.Confirmation];
var SchemeTypeTicketBook_RETURN_TARGET_STEP = 97;
var SchemeTypeTicketBook_RESTART_STEP = 98;

var SchemeTypeTicketBook = function SchemeTypeTicketBook(_ref) {
  var isEmailVerified = _ref.isEmailVerified,
      isLoggedIn = _ref.isLoggedIn;
  var dispatch = (0,src_redux/* useAppDispatch */.TL)();

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return getPurchases(state.merchantsProductsPurchases);
  }, es/* shallowEqual */.wU),
      merchantProduct = _useSelector.merchantProduct,
      publicId = _useSelector.publicId,
      postable = _useSelector.postable,
      settings = _useSelector.settings,
      step = _useSelector.step;

  var renderAuthAt = (0,react.useCallback)(function (step) {
    if (settings === null) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_ProductPurchaseAuth, {
      schemeType: settings.schemeType,
      postable: postable,
      moveToNext: function moveToNext() {
        return dispatch(nextStep(step));
      },
      isEmailVerified: isEmailVerified,
      isLoggedIn: isLoggedIn
    });
  }, [settings, postable, dispatch, isEmailVerified, isLoggedIn]);
  var renderCustomerAt = (0,react.useCallback)(function (step) {
    if (settings === null) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Customer, {
      schemeType: settings.schemeType,
      settings: settings.customer,
      postable: postable,
      onSubmit: function onSubmit() {
        return dispatch(nextStep(step));
      }
    });
  }, [settings, postable, dispatch]);
  var renderPaymentAt = (0,react.useCallback)(function (step) {
    if (!settings || !settings.payment) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_Payment, {
      schemeType: settings.schemeType,
      settings: settings.payment,
      merchantPublicId: publicId,
      postable: postable,
      onSubmit: function onSubmit() {
        return dispatch(nextStep(step));
      }
    });
  }, [settings, postable, dispatch, publicId]);
  var renderConfirmationAt = (0,react.useCallback)(function (step) {
    if (!settings || !merchantProduct) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Confirmation, {
      schemeType: settings.schemeType,
      product: merchantProduct,
      firstCharge: null,
      settings: settings.confirmation,
      postable: postable,
      publicId: publicId,
      onSubmit: function onSubmit() {
        return dispatch(finalStep(step));
      },
      onRestart: function onRestart() {
        return dispatch(goTo(SchemeTypeTicketBook_RESTART_STEP));
      },
      onReturnTargetStep: function onReturnTargetStep() {
        return dispatch(goTo(SchemeTypeTicketBook_RETURN_TARGET_STEP));
      }
    });
  }, [settings, merchantProduct, postable, publicId, dispatch]);
  var renderCompletion = (0,react.useCallback)(function () {
    if (settings === null || !merchantProduct) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_Completion, {
      schemeType: settings.schemeType,
      settings: settings.completion,
      product: merchantProduct,
      firstCharge: null,
      lastOrder: null,
      publicId: publicId
    });
  }, [settings, merchantProduct, publicId]);
  var renderFailedRestart = (0,react.useCallback)(function () {
    var backTo = {
      label: 'purchases.schemeTypeTicketBook.restart',
      modifyPage: function modifyPage() {
        return location.reload();
      }
    };
    if (settings === null) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_CompletionFailed, {
      schemeType: settings.schemeType,
      settings: settings.completion,
      backTo: backTo
    });
  }, [settings]);
  var renderFailedReturnTargetStep = (0,react.useCallback)(function (modifierStep) {
    var backTo = {
      label: 'purchases.schemeTypeTicketBook.returnTargetStep',
      modifyPage: function modifyPage() {
        return dispatch(goTo(modifierStep));
      }
    };
    if (settings === null) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_CompletionFailed, {
      schemeType: settings.schemeType,
      settings: settings.completion,
      backTo: backTo
    });
  }, [settings, dispatch]);
  var fullWorkFlowSetting = (0,react.useCallback)(function () {
    // prettier-ignore
    var setting = {
      0: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderAuthAt(0);
        }
      },
      1: {
        displayProgress: true,
        currentProgress: StepItems.Customer,
        renderFn: function renderFn() {
          return renderCustomerAt(1);
        }
      },
      2: {
        displayProgress: true,
        currentProgress: StepItems.Payment,
        renderFn: function renderFn() {
          return renderPaymentAt(2);
        }
      },
      3: {
        displayProgress: true,
        currentProgress: StepItems.Confirmation,
        renderFn: function renderFn() {
          return renderConfirmationAt(3);
        }
      },
      4: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderCompletion();
        }
      },
      97: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderFailedReturnTargetStep(1);
        }
      },
      98: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderFailedRestart();
        }
      }
    }[step];
    return [SchemeTypeTicketBook_FULL_WORKFLOW_STEPS, setting];
  }, [step, renderAuthAt, renderCustomerAt, renderPaymentAt, renderConfirmationAt, renderCompletion, renderFailedRestart, renderFailedReturnTargetStep]);
  var skipCustomerFlowSetting = (0,react.useCallback)(function () {
    // prettier-ignore
    var setting = {
      0: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderAuthAt(0);
        }
      },
      1: {
        displayProgress: true,
        currentProgress: StepItems.Payment,
        renderFn: function renderFn() {
          return renderPaymentAt(1);
        }
      },
      2: {
        displayProgress: true,
        currentProgress: StepItems.Confirmation,
        renderFn: function renderFn() {
          return renderConfirmationAt(2);
        }
      },
      3: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderCompletion();
        }
      },
      97: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderFailedReturnTargetStep(1);
        }
      },
      98: {
        displayProgress: false,
        currentProgress: null,
        renderFn: function renderFn() {
          return renderFailedRestart();
        }
      }
    }[step];
    return [SchemeTypeTicketBook_SKIP_CUSTOMER_WORKFLOW_STEPS, setting];
  }, [step, renderAuthAt, renderPaymentAt, renderConfirmationAt, renderCompletion, renderFailedRestart, renderFailedReturnTargetStep]);

  var _useMemo = (0,react.useMemo)(function () {
    return settings !== null && settings.customer.customerFields.length !== 0 ? fullWorkFlowSetting() : skipCustomerFlowSetting();
  }, [settings, fullWorkFlowSetting, skipCustomerFlowSetting]),
      allSteps = _useMemo[0],
      setting = _useMemo[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [setting && setting.displayProgress && setting.currentProgress && /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_PurchaseStep, {
      allSteps: allSteps,
      current: allSteps.indexOf(setting.currentProgress) + 1
    }), setting && setting.renderFn()]
  });
};

/* harmony default export */ var purchases_SchemeTypeTicketBook = (SchemeTypeTicketBook);
// EXTERNAL MODULE: ./src/templates/merchants/products/purchases/IndexTemplate/index.module.scss
var IndexTemplate_index_module = __webpack_require__(3490);
var IndexTemplate_index_module_default = /*#__PURE__*/__webpack_require__.n(IndexTemplate_index_module);
// EXTERNAL MODULE: ./src/interfaces/merchants/products.ts
var products = __webpack_require__(12085);
// EXTERNAL MODULE: ./src/templates/merchants/products/purchases/IndexTemplate/components/NotAcceptingPurchase/NotAcceptingPurchase.module.scss
var NotAcceptingPurchase_module = __webpack_require__(4159);
var NotAcceptingPurchase_module_default = /*#__PURE__*/__webpack_require__.n(NotAcceptingPurchase_module);
;// CONCATENATED MODULE: ./src/templates/merchants/products/purchases/IndexTemplate/components/NotAcceptingPurchase/index.tsx







var NotAcceptingPurchase = function NotAcceptingPurchase(_ref) {
  var url = _ref.url;
  var intl = (0,useIntl/* default */.Z)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (NotAcceptingPurchase_module_default()).container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (NotAcceptingPurchase_module_default()).errorMessage,
      children: intl.formatMessage({
        id: "purchases.NotAcceptingPurchase.message"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (NotAcceptingPurchase_module_default()).buttonSection,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.ZP, {
        isGhost: true,
        isFull: true,
        buttonSize: Button/* ButtonSize.Medium */.qE.Medium,
        href: url,
        children: intl.formatMessage({
          id: "purchases.NotAcceptingPurchase.toppage"
        })
      })
    })]
  });
};

/* harmony default export */ var components_NotAcceptingPurchase = (NotAcceptingPurchase);
;// CONCATENATED MODULE: ./src/templates/merchants/products/purchases/IndexTemplate/index.tsx

















var MerchantProductPurchasePage = function MerchantProductPurchasePage(_ref) {
  var _loginUser$is_email_v;

  var productId = _ref.productId,
      publicId = _ref.publicId,
      _ref$merchantDetail = _ref.merchantDetail,
      public_id = _ref$merchantDetail.public_id,
      display_name = _ref$merchantDetail.display_name,
      thumbnail = _ref$merchantDetail.thumbnail,
      show_profile_image_on_site = _ref$merchantDetail.show_profile_image_on_site,
      logo_image = _ref$merchantDetail.logo_image,
      productStatus = _ref.productStatus,
      isCoubicApp = _ref.isCoubicApp;
  var isRenderedRef = (0,react.useRef)(false);
  var dispatch = (0,src_redux/* useAppDispatch */.TL)();

  var _useUserMe = (0,me/* useUserMe */.J1)(),
      isLoggedIn = _useUserMe.isLoggedIn,
      loginUser = _useUserMe.meResponseData;

  var isEmailVerified = (_loginUser$is_email_v = loginUser === null || loginUser === void 0 ? void 0 : loginUser.is_email_verified) !== null && _loginUser$is_email_v !== void 0 ? _loginUser$is_email_v : false;
  useWindowPopstate({
    dispatch: dispatch
  });
  (0,react.useEffect)(function () {
    dispatch(init({
      publicId: publicId,
      productId: productId,
      isEmailVerified: isEmailVerified
    }));
  }, [dispatch, publicId, productId, isEmailVerified]);

  var _useSelector = (0,es/* useSelector */.v9)(function (state) {
    return getPurchases(state.merchantsProductsPurchases);
  }, es/* shallowEqual */.wU),
      settings = _useSelector.settings,
      step = _useSelector.step;

  if (!settings || step === undefined || step === null) {
    return null;
  }

  var isFirstStep = step === 1 || step === 0;

  if (!isRenderedRef.current && !isFirstStep && isLoggedIn) {
    return null;
  }

  isRenderedRef.current = true;
  var merchantProps = {
    publicId: public_id,
    displayName: display_name,
    thumbnailUrl: thumbnail.thumb.url,
    isShowProfileImage: show_profile_image_on_site
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BaseLayoutMerchantWithShortHeader/* default */.Z, {
    className: (IndexTemplate_index_module_default()).Index,
    merchantProps: merchantProps,
    logoImage: logo_image,
    merchantPublicId: public_id,
    isCoubicApp: isCoubicApp,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (IndexTemplate_index_module_default()).Index__PurchasesArea,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (IndexTemplate_index_module_default()).Index__PurchasesContent,
        children: productStatus === products/* MerchantProductStatus.Accepting */.y.Accepting ? /*#__PURE__*/(0,jsx_runtime.jsx)(ProductPurchaseFlow, {
          settings: settings,
          isEmailVerified: isEmailVerified,
          isLoggedIn: isLoggedIn
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_NotAcceptingPurchase, {
          url: "/".concat(publicId, "/products/").concat(productId)
        })
      })
    })
  });
};

var ProductPurchaseFlow = function ProductPurchaseFlow(_ref2) {
  var settings = _ref2.settings,
      isEmailVerified = _ref2.isEmailVerified,
      isLoggedIn = _ref2.isLoggedIn;

  if (!settings) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(LoadingIconWithReloadButton/* LoadingIconWithReloadButton */.b, {});
  }

  if (settings.schemeType === purchases/* SchemeType.Subscription */.Yr.Subscription) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_SchemeTypeSubscription, {
      isEmailVerified: isEmailVerified,
      isLoggedIn: isLoggedIn
    });
  }

  if (settings.schemeType === purchases/* SchemeType.TicketBook */.Yr.TicketBook) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(purchases_SchemeTypeTicketBook, {
      isEmailVerified: isEmailVerified,
      isLoggedIn: isLoggedIn
    });
  }

  (0,esm_exports/* captureException */.Tb)('Never');
  throw new Error('Never');
};

/* harmony default export */ var IndexTemplate = (MerchantProductPurchasePage);
// EXTERNAL MODULE: ./src/templates/ErrorTemplate/index.tsx + 3 modules
var ErrorTemplate = __webpack_require__(26105);
// EXTERNAL MODULE: ./src/molecules/merchant/products/MerchantProductProtectedPage/index.tsx + 1 modules
var MerchantProductProtectedPage = __webpack_require__(13513);
// EXTERNAL MODULE: ./src/components/MerchantSite/index.tsx
var MerchantSite = __webpack_require__(7818);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/pages/[publicId]/products/[productId]/purchase/index.tsx
















var subscribedBy = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(productId) {
    var userSubscription;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,api/* fetchUsersSubscription */.l)(productId);

          case 2:
            userSubscription = _context.sent;
            return _context.abrupt("return", !!userSubscription);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function subscribedBy(_x) {
    return _ref.apply(this, arguments);
  };
}();

var MerchantProductPurchase = function MerchantProductPurchase(props) {
  var _merchantDetail$favic;

  var merchantDetail = props.merchantDetail,
      isUnpublishedSite = props.isUnpublishedSite,
      isPasswordProtected = props.isPasswordProtected,
      publicId = props.publicId,
      productId = props.productId,
      productStatus = props.productStatus,
      isCoubicApp = props.isCoubicApp;
  var intl = (0,useIntl/* default */.Z)();
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(isPasswordProtected),
      passwordProtected = _useState[0],
      setPasswordProtected = _useState[1];

  var onPasswordSubmit = function onPasswordSubmit(isCorrectPassword) {
    if (isCorrectPassword) {
      setPasswordProtected(false);
    }
  };

  (0,gtm/* usePushMerchantDataLayerEffect */.O)({
    visit_merchant_id: merchantDetail === null || merchantDetail === void 0 ? void 0 : merchantDetail.id
  });
  (0,react.useEffect)(function () {
    var subscribedCheck = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
        var subscribed;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return subscribedBy(productId);

              case 2:
                subscribed = _context2.sent;

                if (subscribed) {
                  router.push("/".concat(publicId));
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function subscribedCheck() {
        return _ref2.apply(this, arguments);
      };
    }();

    subscribedCheck();
  }, [productId, publicId, router]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantSite/* MerchantSite */.Z, {
    isUnPublished: isUnpublishedSite,
    isMerchantInfoExist: !!merchantDetail,
    isProtected: passwordProtected,
    protectedElement: /*#__PURE__*/(0,jsx_runtime.jsx)(MerchantProductProtectedPage/* default */.Z, {
      publicId: publicId,
      productPublicId: productId,
      onSubmit: onPasswordSubmit
    }),
    logoImage: (merchantDetail === null || merchantDetail === void 0 ? void 0 : merchantDetail.logo_image) || null,
    merchantPublicId: (merchantDetail === null || merchantDetail === void 0 ? void 0 : merchantDetail.public_id) || null,
    displayName: (merchantDetail === null || merchantDetail === void 0 ? void 0 : merchantDetail.display_name) || null,
    isCoubicApp: isCoubicApp,
    children: merchantDetail ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
        title: intl.formatMessage({
          id: 'purchases.meta.title'
        }),
        noIndex: true,
        googleAnalyticsFourTrackingId: merchantDetail.available_google_analytics_four_tracking_id,
        faviconImageUrl: merchantDetail === null || merchantDetail === void 0 ? void 0 : (_merchantDetail$favic = merchantDetail.favicon_image) === null || _merchantDetail$favic === void 0 ? void 0 : _merchantDetail$favic.url
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(IndexTemplate, {
        publicId: publicId,
        merchantDetail: merchantDetail,
        productId: productId,
        productStatus: productStatus,
        isCoubicApp: isCoubicApp
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorTemplate/* default */.Z, {
      statusCode: 404
    })
  });
};

var __N_SSP = true;
/* harmony default export */ var purchase = (MerchantProductPurchase);

/***/ }),

/***/ 41239:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/products/[productId]/purchase",
      function () {
        return __webpack_require__(26653);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 28742:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__MEuQu","isGray":"Tag_isGray__DYThc"};

/***/ }),

/***/ 84751:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Icon":"Icon_Icon__HjWlJ"};

/***/ }),

/***/ 18170:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PurchaseFlowMerchantHeader":"PurchaseFlowMerchantHeader_PurchaseFlowMerchantHeader__lHoQo","PurchaseFlowMerchantHeader__Inner":"PurchaseFlowMerchantHeader_PurchaseFlowMerchantHeader__Inner__hEnxx","PurchaseFlowMerchantHeader__Link":"PurchaseFlowMerchantHeader_PurchaseFlowMerchantHeader__Link__z5Pdz","PurchaseFlowMerchantHeader__Image":"PurchaseFlowMerchantHeader_PurchaseFlowMerchantHeader__Image___L_53","PurchaseFlowMerchantHeader__Description":"PurchaseFlowMerchantHeader_PurchaseFlowMerchantHeader__Description__GrISC"};

/***/ }),

/***/ 20655:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BookingPageCard":"BookingPageCard_BookingPageCard__fmwb5","BookingPageCard__Link":"BookingPageCard_BookingPageCard__Link__M2dAw","BookingPageCard__Thumbnail":"BookingPageCard_BookingPageCard__Thumbnail__JhxU6","BookingPageCard__ThumbnailImage":"BookingPageCard_BookingPageCard__ThumbnailImage__V82jf","BookingPageCard__Heading":"BookingPageCard_BookingPageCard__Heading__vbzvC","BookingPageCard__Description":"BookingPageCard_BookingPageCard__Description__j9zJ2","BookingPageCard__Clearfix":"BookingPageCard_BookingPageCard__Clearfix__Gzhzu","BookingPageCard__Footer":"BookingPageCard_BookingPageCard__Footer__DUxiB","BookingPageCard__Price":"BookingPageCard_BookingPageCard__Price__obXSG","BookingPageCard__Tags":"BookingPageCard_BookingPageCard__Tags__8_j0q"};

/***/ }),

/***/ 77050:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MerchantTag":"MerchantTag_MerchantTag__gr0Qn","isAccepting":"MerchantTag_isAccepting__Hr8x5","isClosed":"MerchantTag_isClosed__H2nnX","isCreditCard":"MerchantTag_isCreditCard__7_X0t","isOnsite":"MerchantTag_isOnsite__m7Lh_","isBankTransfer":"MerchantTag_isBankTransfer__7PFCW","isTicket":"MerchantTag_isTicket__S93zM","isSubscription":"MerchantTag_isSubscription__lye9M","isRequireAcceptance":"MerchantTag_isRequireAcceptance__YSDbw"};

/***/ }),

/***/ 92706:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"LowestPrice":"LowestPrice_LowestPrice__ZU1tL","LowestPrice__Emphasis":"LowestPrice_LowestPrice__Emphasis__5HvM8"};

/***/ }),

/***/ 80028:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MerchantProductProtectedPage":"MerchantProductProtectedPage_MerchantProductProtectedPage__qzD1p","MerchantProductProtectedPage__Img":"MerchantProductProtectedPage_MerchantProductProtectedPage__Img__rTQWM","MerchantProductProtectedPage__Notes":"MerchantProductProtectedPage_MerchantProductProtectedPage__Notes__jGzjk","MerchantProductProtectedPage__Heading":"MerchantProductProtectedPage_MerchantProductProtectedPage__Heading__8_lsY","MerchantProductProtectedPage__Description":"MerchantProductProtectedPage_MerchantProductProtectedPage__Description__nwdJT","MerchantProductProtectedPage__Password":"MerchantProductProtectedPage_MerchantProductProtectedPage__Password__Aa8Qy"};

/***/ }),

/***/ 58174:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AvailableBookingPageList":"AvailableBookingPageList_AvailableBookingPageList__f5uM9","AvailableBookingPageList__BookingPageCard":"AvailableBookingPageList_AvailableBookingPageList__BookingPageCard__tjPEk"};

/***/ }),

/***/ 68041:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CompletionFailed":"CompletionFailed_CompletionFailed__vzrgr","CompletionFailed__ErrorMessage":"CompletionFailed_CompletionFailed__ErrorMessage__6OSSy"};

/***/ }),

/***/ 67667:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PurchaseBackToTop":"PurchaseBackToTop_PurchaseBackToTop__EUCI_"};

/***/ }),

/***/ 51390:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PurchaseCompleteAlert":"PurchaseCompleteAlert_PurchaseCompleteAlert__2O6Qo","PurchaseCompleteAlert__Title":"PurchaseCompleteAlert_PurchaseCompleteAlert__Title__fxHcC","PurchaseCompleteAlert__Text":"PurchaseCompleteAlert_PurchaseCompleteAlert__Text__KKYLj","PurchaseCompleteAlert__Emphasis":"PurchaseCompleteAlert_PurchaseCompleteAlert__Emphasis__TJkyb"};

/***/ }),

/***/ 32530:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PurchaseErrorMessage":"PurchaseErrorMessage_PurchaseErrorMessage__I1tOT","PurchaseErrorMessage__Title":"PurchaseErrorMessage_PurchaseErrorMessage__Title__qavIv","PurchaseErrorMessage__Paragraph":"PurchaseErrorMessage_PurchaseErrorMessage__Paragraph__R3YSm"};

/***/ }),

/***/ 85343:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PurchaseItemList":"PurchaseItemList_PurchaseItemList__vZD5w","PurchaseItemList__Link":"PurchaseItemList_PurchaseItemList__Link__qdK49","PurchaseItemList__Inner":"PurchaseItemList_PurchaseItemList__Inner__5sZ4A","PurchaseItemList__Image":"PurchaseItemList_PurchaseItemList__Image__sslHX","PurchaseItemList__Name":"PurchaseItemList_PurchaseItemList__Name__WoyLt","PurchaseItemList__Id":"PurchaseItemList_PurchaseItemList__Id__SZkgZ","PurchaseItemList__AdmissionDate":"PurchaseItemList_PurchaseItemList__AdmissionDate__NCxLP","PurchaseItemList__List":"PurchaseItemList_PurchaseItemList__List__twFXz","PurchaseItemList__ListTitle":"PurchaseItemList_PurchaseItemList__ListTitle__FN3Ad","PurchaseItemList__ListData":"PurchaseItemList_PurchaseItemList__ListData__qLRBE","PurchaseItemList__Explanation":"PurchaseItemList_PurchaseItemList__Explanation__27URh"};

/***/ }),

/***/ 41497:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PurchaseStep":"PurchaseStep_PurchaseStep__e6psJ","PurchaseStep__StepNumber":"PurchaseStep_PurchaseStep__StepNumber__BJhuE","PurchaseStep__StepLabel":"PurchaseStep_PurchaseStep__StepLabel__gJEvx","PurchaseStep__Item":"PurchaseStep_PurchaseStep__Item__Kg8u4","isCurrent":"PurchaseStep_isCurrent__T4mig","isDone":"PurchaseStep_isDone__G9hW8"};

/***/ }),

/***/ 28368:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PurchaseVerifyUserAlert":"PurchaseVerifyUserAlert_PurchaseVerifyUserAlert__JNqo6","PurchaseVerifyUserAlert__Title":"PurchaseVerifyUserAlert_PurchaseVerifyUserAlert__Title__mMh4v","PurchaseVerifyUserAlert__Description":"PurchaseVerifyUserAlert_PurchaseVerifyUserAlert__Description__efY3o"};

/***/ }),

/***/ 34544:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Subscribed":"Subscribed_Subscribed__YvdCz","Subscribed__MessageSection":"Subscribed_Subscribed__MessageSection__rvlIG","Subscribed__MessageTitle":"Subscribed_Subscribed__MessageTitle__95HLP","Subscribed__MessageParagraph":"Subscribed_Subscribed__MessageParagraph__eRJ0Y"};

/***/ }),

/***/ 752:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PurchaseCreateUserConfirmAlert":"PurchaseCreateUserConfirmAlert_PurchaseCreateUserConfirmAlert__xKtQU","PurchaseCreateUserConfirmAlert__Paragraph":"PurchaseCreateUserConfirmAlert_PurchaseCreateUserConfirmAlert__Paragraph__FPLYr","isBold":"PurchaseCreateUserConfirmAlert_isBold__PB21A","PurchaseCreateUserConfirmAlert__Em":"PurchaseCreateUserConfirmAlert_PurchaseCreateUserConfirmAlert__Em__2uW7I","PurchaseCreateUserConfirmAlert__Link":"PurchaseCreateUserConfirmAlert_PurchaseCreateUserConfirmAlert__Link__z_yX_"};

/***/ }),

/***/ 84792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PurchaseLoginRequireAlert":"PurchaseLoginRequireAlert_PurchaseLoginRequireAlert__ABJY8","PurchaseLoginRequireAlert__Paragraph":"PurchaseLoginRequireAlert_PurchaseLoginRequireAlert__Paragraph__pfScd","isBold":"PurchaseLoginRequireAlert_isBold__mYUmf","PurchaseLoginRequireAlert__Em":"PurchaseLoginRequireAlert_PurchaseLoginRequireAlert__Em__gZq0m","PurchaseLoginRequireAlert__Link":"PurchaseLoginRequireAlert_PurchaseLoginRequireAlert__Link__hDbEH"};

/***/ }),

/***/ 10068:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PurchaseConfirmAlert":"PurchaseConfirmAlert_PurchaseConfirmAlert__Z_jJZ","PurchaseConfirmAlert__Paragraph":"PurchaseConfirmAlert_PurchaseConfirmAlert__Paragraph__vhonV","isBold":"PurchaseConfirmAlert_isBold__k_vh8","PurchaseConfirmAlert__Em":"PurchaseConfirmAlert_PurchaseConfirmAlert__Em__GZZIe","PurchaseConfirmAlert__Link":"PurchaseConfirmAlert_PurchaseConfirmAlert__Link__5HeRQ"};

/***/ }),

/***/ 48772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card_brand_list_wrapper":"PaymentMethodsSelector_card_brand_list_wrapper__um9aM"};

/***/ }),

/***/ 41703:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PurchasePaymentCard":"PurchasePaymentCard_PurchasePaymentCard__ZV7Sk","PurchasePaymentCard__Card":"PurchasePaymentCard_PurchasePaymentCard__Card__uKYHp","PurchasePaymentCard__Mask":"PurchasePaymentCard_PurchasePaymentCard__Mask__Pm_ew"};

/***/ }),

/***/ 4159:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"NotAcceptingPurchase_container__BgJON","errorMessage":"NotAcceptingPurchase_errorMessage__zi087","buttonSection":"NotAcceptingPurchase_buttonSection___8g_C"};

/***/ }),

/***/ 3490:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Index":"IndexTemplate_Index__OIp2d","Index__PurchasesArea":"IndexTemplate_Index__PurchasesArea__KiiLD","Index__PurchasesContent":"IndexTemplate_Index__PurchasesContent__PtBNx"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,9169,9267,320,7962,6105,981,5826,9774,2888,179], function() { return __webpack_exec__(41239); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);